import { __awaiter, __decorate, __metadata, __param } from 'tslib';
import { CommonModule } from '@angular/common';
import { Injectable, NgModule, Optional, SkipSelf } from '@angular/core';
import { FormControl, Validators, FormBuilder, FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { IonicModule } from '@ionic/angular';
import { Storage, IonicStorageModule } from '@ionic/storage';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { APP_PARAMETER } from '@wlp/ui-bs-parameter';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { BaseService, ErrorMessageService, DocumentValidator, UfService, DateValidator, MoneyValidator, minOrEqualValueValidator, MaskService, CertifiedService, UiBsUtilModule } from '@wlp/ui-bs-util';
import { SpeNOpenAccountProxy, ConfigService, SpeViewPreAccountProxy, Status, TypeAccountEnum as TypeAccountEnum$1, UploadTypeEnum, PositionPhotoEnum, SpeNOpenAccountUploadProxy, UiPxSignupModule } from '@wlp/ui-px-signup';
export { CreateLivenessBodyDTO, CreateLivenessResponseDTO, LivenessOnboardingResponseDTO, ProcessResultUnicoEnum, ProcessStatusUnicoEnum, Status } from '@wlp/ui-px-signup';
import { BehaviorSubject, of } from 'rxjs';
import { AuthUtilBase } from '@wlp//ui-bs-oauth';
import { tap, catchError, map } from 'rxjs/operators';

let AccountTypeService = class AccountTypeService extends BaseService {
    constructor(speNOpenAccountProxy, configService, storage, speViewPreAccountProxy, errorMessageService) {
        super(storage, configService);
        this.speNOpenAccountProxy = speNOpenAccountProxy;
        this.configService = configService;
        this.storage = storage;
        this.speViewPreAccountProxy = speViewPreAccountProxy;
        this.errorMessageService = errorMessageService;
    }
    loadRegisteredAccountType() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            return this.speViewPreAccountProxy.findAccountType(this.keyPreAccount).toPromise();
        });
    }
    loadUploadsArray() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            return this.speViewPreAccountProxy.findUploads(this.keyPreAccount).toPromise();
        });
    }
    loadTypeAccount(idWhiteLabel) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            let temporary = yield this.getTemporaryTypeAccount();
            let listType = yield this.speViewPreAccountProxy.findAccountTypeByWhiteLabel(idWhiteLabel).toPromise();
            if (temporary) {
                return listType.filter((type) => {
                    return type.typeFlow === temporary;
                });
            }
            else {
                return listType;
            }
        });
    }
    loadTypeAccountToUnicoFlow(idWhiteLabel) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            let temporary = yield this.getTemporaryTypeAccount();
            let listType = yield this.speViewPreAccountProxy.findAccountTypeByWhiteLabelVisible(idWhiteLabel).toPromise();
            if (temporary) {
                return listType.filter((type) => {
                    return type.typeFlow === temporary;
                });
            }
            else {
                return listType;
            }
        });
    }
    defineTypeAccount(accountPaymentType, nextStep) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            return this.speNOpenAccountProxy.createTypeAccount(this.keyPreAccount, accountPaymentType, nextStep).toPromise();
        });
    }
    accountIsMoreFiveK() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            return this.speNOpenAccountProxy.accountIsMoreFivek(this.keyPreAccount).toPromise();
        });
    }
    temporaryTypeAccount(typeflow) {
        return __awaiter(this, void 0, void 0, function* () {
            this.storage.set('temporaryTypeAccount', typeflow);
        });
    }
    getTemporaryTypeAccount() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.storage.get('temporaryTypeAccount');
        });
    }
    setName(name) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.storage.set('accountName', name);
        });
    }
    getName() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.storage.get('accountName');
        });
    }
    getAccount() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            return this.speNOpenAccountProxy.getPreAccount(this.keyPreAccount).toPromise();
        });
    }
    setNameType(type) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.storage.set('nameType', type);
        });
    }
    getNameType() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.storage.get('nameType');
        });
    }
    setListStep(data) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.storage.set('listStep', data);
        });
    }
    getListStep() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.storage.get('listStep');
        });
    }
    getErrorMessages(err) {
        this.errorMessageService.getError(err);
    }
    getSteps(uuidWhiteLabel, accountType) {
        return this.speViewPreAccountProxy.getSteps(uuidWhiteLabel, accountType);
    }
};
AccountTypeService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [SpeNOpenAccountProxy,
        ConfigService,
        Storage,
        SpeViewPreAccountProxy,
        ErrorMessageService])
], AccountTypeService);

class BusinessPartnerResponse {
}

let AddPartnerService = class AddPartnerService extends BaseService {
    constructor(formBuilder, speNOpenAccountProxy, speViewPreAccountProxy, storage, configService, errorMessageService) {
        super(storage, configService);
        this.formBuilder = formBuilder;
        this.speNOpenAccountProxy = speNOpenAccountProxy;
        this.speViewPreAccountProxy = speViewPreAccountProxy;
        this.storage = storage;
        this.configService = configService;
        this.errorMessageService = errorMessageService;
        this.errorMessages = {
            fullname: [
                { type: 'required', message: 'ONBORDING.ADD_PARTNERS.FORM.FULLNAME.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'ONBORDING.ADD_PARTNERS.FORM.FULLNAME.MESSAGE.MIN_LENGTH',
                    param: { minLength: 6 }
                },
                {
                    type: 'maxlength',
                    message: 'ONBORDING.ADD_PARTNERS.FORM.FULLNAME.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 100 }
                },
            ],
            docNumber: [
                { type: 'required', message: 'ONBORDING.ADD_PARTNERS.FORM.CPF.MESSAGE.REQUIRED' },
                { type: 'cpfNotValid', message: 'ONBORDING.ADD_PARTNERS.FORM.CPF.MESSAGE.CPF_NOT_VALID' }
            ]
        };
        this.businessPartnerList = [];
        this.behaviorList = new BehaviorSubject([]);
    }
    getErrorBusinessPartner(error) {
        this.errorMessageService.getError(error);
    }
    updateForm() {
        return __awaiter(this, void 0, void 0, function* () {
            this.businessPartnerList = [];
            yield this.loadKey();
            if (!!this.keyPreAccount) {
                this.getPreAccount(this.keyPreAccount);
            }
        });
    }
    getPreAccount(uuid) {
        this.keyPreAccount = uuid;
        this.speViewPreAccountProxy
            .findPartners(uuid)
            .subscribe(data => {
            this.preAccountBody = data;
            if (data.businessPartner !== undefined && data.businessPartner.length > 0) {
                this.businessPartnerList = data.businessPartner;
                this.behaviorList.next(this.businessPartnerList);
            }
            else {
                this.includeFirstPartner(data);
            }
        }, err => this.errorMessageService.getError(err));
        return this.businessPartnerList;
    }
    getListPartners() {
        return this.behaviorList;
    }
    includeFirstPartner(preAccount) {
        this.preAccountBody = preAccount;
        const businessPartnerObj = new BusinessPartnerResponse();
        businessPartnerObj.fullname = preAccount.name;
        businessPartnerObj.docNumber = preAccount.cpf;
        businessPartnerObj.legalRepresentative = false;
        businessPartnerObj.attorney = false;
        businessPartnerObj.partner = false;
        businessPartnerObj.master = true;
        this.businessPartnerList.push(businessPartnerObj);
        this.preAccountBody.businessPartner = this.businessPartnerList;
        this.editForm(businessPartnerObj);
        this.sendFirstBusinessPartner(this.preAccountBody);
    }
    sendFirstBusinessPartner(preAccount) {
        this.speNOpenAccountProxy.updateBusinessPartner(this.keyPreAccount, preAccount)
            .subscribe(res => {
            // console.log('res', res);
        }, error => {
            // console.error('error', error);
        });
    }
    editForm(businessPartner) {
        this.formBusinessPartner.patchValue({
            fullname: businessPartner.fullname,
            docNumber: businessPartner.docNumber,
            legalRepresentative: businessPartner.legalRepresentative,
            attorney: businessPartner.attorney,
            partner: businessPartner.partner,
            master: businessPartner.master
        });
        return this.formBusinessPartner;
    }
    getFormBusinessPartner() {
        this.formBusinessPartner = this.formBuilder.group({
            fullname: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(6),
                Validators.maxLength(100)
            ])),
            docNumber: new FormControl('', Validators.compose([
                Validators.required,
                DocumentValidator.isValidCPF
            ])),
            legalRepresentative: false,
            attorney: false,
            partner: false,
            master: false
        });
        return this.formBusinessPartner;
    }
    getFormMessageError() {
        return this.errorMessages;
    }
    addNewPartner(form) {
        const partnerItem = form.getRawValue();
        const businessPartnerResponse = new BusinessPartnerResponse();
        businessPartnerResponse.fullname = partnerItem.fullname;
        businessPartnerResponse.docNumber = partnerItem.docNumber;
        businessPartnerResponse.legalRepresentative = partnerItem.legalRepresentative;
        businessPartnerResponse.attorney = partnerItem.attorney;
        businessPartnerResponse.partner = partnerItem.partner;
        businessPartnerResponse.master = false;
        this.preAccountBody.businessPartner.push(businessPartnerResponse);
        this.sendBusinessPartner(this.preAccountBody);
    }
    editPartner(form, index) {
        const partnerItem = form.getRawValue();
        const businessPartnerResponse = new BusinessPartnerResponse();
        businessPartnerResponse.fullname = partnerItem.fullname;
        businessPartnerResponse.docNumber = partnerItem.docNumber;
        businessPartnerResponse.legalRepresentative = partnerItem.legalRepresentative;
        businessPartnerResponse.attorney = partnerItem.attorney;
        businessPartnerResponse.partner = partnerItem.partner;
        businessPartnerResponse.master = partnerItem.master;
        this.preAccountBody.businessPartner.splice(index, 1, businessPartnerResponse);
        this.sendBusinessPartner(this.preAccountBody);
    }
    removePartner(index) {
        this.preAccountBody.businessPartner.splice(index, 1);
        this.sendBusinessPartner(this.preAccountBody);
    }
    sendBusinessPartner(preAccount) {
        this.speNOpenAccountProxy.updateBusinessPartner(this.keyPreAccount, preAccount)
            .subscribe(res => {
            this.behaviorList.next(res.businessPartner);
        }, error => {
            // console.error('error', error);
        });
    }
};
AddPartnerService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [FormBuilder,
        SpeNOpenAccountProxy,
        SpeViewPreAccountProxy,
        Storage,
        ConfigService,
        ErrorMessageService])
], AddPartnerService);

let BusinessPartnerService = class BusinessPartnerService extends BaseService {
    constructor(formBuilder, speNOpenAccountProxy, speViewPreAccountProxy, storage, configService, errorMessageService) {
        super(storage, configService);
        this.formBuilder = formBuilder;
        this.speNOpenAccountProxy = speNOpenAccountProxy;
        this.speViewPreAccountProxy = speViewPreAccountProxy;
        this.storage = storage;
        this.configService = configService;
        this.errorMessageService = errorMessageService;
        this.errorMessages = {
            fullname: [
                { type: 'required', message: 'Campo obrigatório' },
                { type: 'minlength', message: 'Deve ser maior ou igual a 6 caracteres' },
                { type: 'maxlength', message: 'Não pode exceder 100 caracteres' },
            ],
            docNumber: [
                { type: 'required', message: 'Campo obrigatório' },
                { type: 'cpfNotValid', message: 'CPF Digitado não é válido' },
            ],
        };
        this.businessPartnerList = [];
        this.behaviorList = new BehaviorSubject([]);
    }
    getErrorBusinessPartner(error) {
        this.errorMessageService.getError(error);
    }
    updateForm() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            if (!!this.keyPreAccount) {
                this.getPreAccount(this.keyPreAccount);
            }
        });
    }
    getPreAccount(uuid) {
        this.speViewPreAccountProxy.findPartners(uuid).subscribe((data) => {
            this.preAccountBody = data;
            if (data.businessPartner !== undefined && data.businessPartner.length > 0) {
                this.businessPartnerList = data.businessPartner;
                this.behaviorList.next(this.businessPartnerList);
            }
            else {
                this.includeFirstPartner(data);
            }
        }, (err) => this.errorMessageService.getError(err));
    }
    getListPartners() {
        return this.behaviorList;
    }
    includeFirstPartner(preAccount) {
        this.preAccountBody = preAccount;
        const businessPartnerObj = new BusinessPartnerResponse();
        businessPartnerObj.fullname = preAccount.name;
        businessPartnerObj.docNumber = preAccount.cpf;
        businessPartnerObj.legalRepresentative = false;
        businessPartnerObj.attorney = false;
        businessPartnerObj.partner = false;
        businessPartnerObj.master = true;
        this.businessPartnerList.push(businessPartnerObj);
        this.preAccountBody.businessPartner = this.businessPartnerList;
        this.sendBusinessPartner(this.preAccountBody);
    }
    editForm(businessPartner) {
        this.formBusinessPartner.patchValue({
            fullname: businessPartner.fullname,
            docNumber: businessPartner.docNumber,
            legalRepresentative: businessPartner.legalRepresentative,
            attorney: businessPartner.attorney,
            partner: businessPartner.partner,
            master: businessPartner.master,
        });
        return this.formBusinessPartner;
    }
    getFormBusinessPartner() {
        this.formBusinessPartner = this.formBuilder.group({
            fullname: new FormControl('', Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(100)])),
            docNumber: new FormControl('', Validators.compose([Validators.required, DocumentValidator.isValidCPF])),
            legalRepresentative: false,
            attorney: false,
            partner: false,
            master: false,
        });
        return this.formBusinessPartner;
    }
    getFormMessageError() {
        return this.errorMessages;
    }
    addNewPartner(form) {
        const partnerItem = form.getRawValue();
        const businessPartnerResponse = new BusinessPartnerResponse();
        businessPartnerResponse.fullname = partnerItem.fullname;
        businessPartnerResponse.docNumber = partnerItem.docNumber;
        businessPartnerResponse.legalRepresentative = partnerItem.legalRepresentative;
        businessPartnerResponse.attorney = partnerItem.attorney;
        businessPartnerResponse.partner = partnerItem.partner;
        businessPartnerResponse.master = false;
        this.preAccountBody.businessPartner.push(businessPartnerResponse);
        this.sendBusinessPartner(this.preAccountBody);
    }
    editPartner(form, index) {
        const partnerItem = form.getRawValue();
        const businessPartnerResponse = new BusinessPartnerResponse();
        businessPartnerResponse.fullname = partnerItem.fullname;
        businessPartnerResponse.docNumber = partnerItem.docNumber;
        businessPartnerResponse.legalRepresentative = partnerItem.legalRepresentative;
        businessPartnerResponse.attorney = partnerItem.attorney;
        businessPartnerResponse.partner = partnerItem.partner;
        businessPartnerResponse.master = partnerItem.master;
        this.preAccountBody.businessPartner.splice(index, 1, businessPartnerResponse);
        this.sendBusinessPartner(this.preAccountBody);
    }
    removePartner(index) {
        this.preAccountBody.businessPartner.splice(index, 1);
        this.sendBusinessPartner(this.preAccountBody)
            .then((res) => { })
            .catch((erro) => console.error('Ocorreu erro pra remover o Sócio ', erro));
    }
    sendBusinessPartner(preAccount) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            this.speNOpenAccountProxy.updateBusinessPartner(this.keyPreAccount, preAccount).subscribe((res) => this.behaviorList.next(res.businessPartner), (error) => {
                // console.error('error', error);
            });
        });
    }
};
BusinessPartnerService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [FormBuilder,
        SpeNOpenAccountProxy,
        SpeViewPreAccountProxy,
        Storage,
        ConfigService,
        ErrorMessageService])
], BusinessPartnerService);

class ComercialAgentDataResponse {
}

class PreAccountResponse {
    constructor() {
        this.businessPartner = [];
    }
}

let ComercialAgentService = class ComercialAgentService extends BaseService {
    constructor(formBuilder, speNOpenAccountProxy, speViewPreAccountProxy, storage, configService, errorMessageService) {
        super(storage, configService);
        this.formBuilder = formBuilder;
        this.speNOpenAccountProxy = speNOpenAccountProxy;
        this.speViewPreAccountProxy = speViewPreAccountProxy;
        this.storage = storage;
        this.configService = configService;
        this.errorMessageService = errorMessageService;
        this.errorMessages = {
            nameAgent: [
                { type: 'minlength', message: 'ONBORDING.COMERCIAL_AGENT.FORM.NAME_AGENT.MESSAGE.MIN_LENGTH' },
                { type: 'maxlength', message: 'ONBORDING.COMERCIAL_AGENT.FORM.NAME_AGENT.MESSAGE.MAX_LENGTH' },
            ],
            cpfAgent: [
                { type: 'cpfNotValid', message: 'ONBORDING.COMERCIAL_AGENT.FORM.CPF_AGENT.MESSAGE.CPF_NOT_VALID' }
            ]
        };
    }
    getFormComercialAgent() {
        this.formComercialAgent = this.formBuilder.group({
            nameAgent: new FormControl('', Validators.compose([
                Validators.minLength(6),
                Validators.maxLength(100)
            ])),
            cpfAgent: new FormControl('', Validators.compose([
                DocumentValidator.isValidCPF
            ]))
        });
        return this.formComercialAgent;
    }
    getMessageError() {
        return this.errorMessages;
    }
    sendComercialAgentData(form) {
        const comercialAgentData = this.prepareComercialAgentData(form);
        return this.speNOpenAccountProxy.updateComercialAgent(this.keyPreAccount, comercialAgentData);
    }
    getErrorComercialAgentData(error) {
        this.errorMessageService.getError(error);
    }
    updateForm() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            if (!!this.keyPreAccount) {
                this.getPreAccount(this.keyPreAccount);
            }
        });
    }
    getPreAccount(uuid) {
        this.keyPreAccount = uuid;
        this.speViewPreAccountProxy
            .findComercialAgent(uuid)
            .subscribe(data => !!data.comercialAgentData ? this.syncForm(data.comercialAgentData) : null, err => this.errorMessageService.getError(err));
    }
    syncForm(comercialAgentData) {
        this.formComercialAgent.patchValue({
            nameAgent: comercialAgentData.nameAgent,
            cpfAgent: comercialAgentData.cpfAgent,
        });
    }
    prepareComercialAgentData(form) {
        const preAccountResponse = new PreAccountResponse();
        const comercialAgentDataResponse = new ComercialAgentDataResponse();
        const data = form.getRawValue();
        comercialAgentDataResponse.nameAgent = data.nameAgent;
        comercialAgentDataResponse.cpfAgent = data.cpfAgent;
        preAccountResponse._id = this.keyPreAccount;
        preAccountResponse.comercialAgentData = comercialAgentDataResponse;
        return preAccountResponse;
    }
};
ComercialAgentService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [FormBuilder,
        SpeNOpenAccountProxy,
        SpeViewPreAccountProxy,
        Storage,
        ConfigService,
        ErrorMessageService])
], ComercialAgentService);

class CompanyAddressResponse {
}

let CompanyAddressService = class CompanyAddressService extends BaseService {
    constructor(storage, formBuilder, ufService, configService, speNOpenAccountProxy, speViewPreAccountProxy, errorMessageService) {
        super(storage, configService);
        this.storage = storage;
        this.formBuilder = formBuilder;
        this.ufService = ufService;
        this.configService = configService;
        this.speNOpenAccountProxy = speNOpenAccountProxy;
        this.speViewPreAccountProxy = speViewPreAccountProxy;
        this.errorMessageService = errorMessageService;
        this.errorMessages = {
            postalCode: [
                { type: 'required', message: 'ONBORDING.COMPANY_ADDRESS.FORM.POSTALCODE.MESSAGE.REQUIRED' },
                { type: 'minlength', message: 'ONBORDING.COMPANY_ADDRESS.FORM.POSTALCODE.MESSAGE.MIN_LENGTH', param: { minLength: 9 } },
                { type: 'pattern', message: 'ONBORDING.COMPANY_ADDRESS.FORM.POSTALCODE.MESSAGE.PATTERN' }
            ],
            address: [
                { type: 'required', message: 'ONBORDING.COMPANY_ADDRESS.FORM.ADDRESS.MESSAGE.REQUIRED' },
                { type: 'minlength', param: { minLength: 3 }, message: 'ONBORDING.COMPANY_ADDRESS.FORM.ADDRESS.MESSAGE.MIN_LENGTH' },
                { type: 'maxlength', param: { maxLength: 200 }, message: 'ONBORDING.COMPANY_ADDRESS.FORM.ADDRESS.MESSAGE.MAX_LENGTH' },
            ],
            numberAddress: [
                { type: 'required', message: 'ONBORDING.COMPANY_ADDRESS.FORM.NUMBER_ADDRESS.MESSAGE.REQUIRED' },
                { type: 'maxlength', param: { maxLength: 5 }, message: 'ONBORDING.COMPANY_ADDRESS.FORM.NUMBER_ADDRESS.MESSAGE.MAX_LENGTH' },
            ],
            complementAddress: [
                { type: 'maxlength', param: { maxLength: 60 }, message: 'ONBORDING.COMPANY_ADDRESS.FORM.COMPLEMENT_ADDRESS.MESSAGE.MAX_LENGTH' }
            ],
            neighborhood: [
                { type: 'required', message: 'ONBORDING.COMPANY_ADDRESS.FORM.NEIGHBORHOOD.MESSAGE.REQUIRED' },
                { type: 'minlength', param: { minLength: 3 }, message: 'ONBORDING.COMPANY_ADDRESS.FORM.NEIGHBORHOOD.MESSAGE.MIN_LENGTH' },
                { type: 'maxlength', param: { maxLength: 60 }, message: 'ONBORDING.COMPANY_ADDRESS.FORM.NEIGHBORHOOD.MESSAGE.MAX_LENGTH' }
            ],
            cityAddress: [
                { type: 'required', message: 'ONBORDING.COMPANY_ADDRESS.FORM.CITY_ADDRESS.MESSAGE.REQUIRED' },
                { type: 'minlength', param: { minLength: 3 }, message: 'ONBORDING.COMPANY_ADDRESS.FORM.CITY_ADDRESS.MESSAGE.MIN_LENGTH' },
                { type: 'maxlength', param: { maxLength: 30 }, message: 'ONBORDING.COMPANY_ADDRESS.FORM.CITY_ADDRESS.MESSAGE.MAX_LENGTH' }
            ],
            uf: [
                { type: 'required', message: 'ONBORDING.COMPANY_ADDRESS.FORM.UF.MESSAGE.REQUIRED' }
            ],
            country: [
                { type: 'required', message: 'Campo obrigatório' },
            ],
        };
    }
    getErrorMessage() {
        return this.errorMessages;
    }
    getCompanyAddressForm() {
        this.formCompanyAddress = this.formBuilder.group({
            postalCode: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(9),
                Validators.pattern('^[a-zA-Z0-9_.+-]+$')
            ])),
            address: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(3),
                Validators.maxLength(200),
            ])),
            numberAddress: new FormControl('', Validators.compose([
                Validators.required,
                Validators.maxLength(5),
            ])),
            complementAddress: new FormControl('', Validators.compose([
                Validators.maxLength(60),
            ])),
            neighborhood: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(3),
                Validators.maxLength(60)
            ])),
            cityAddress: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(3),
                Validators.maxLength(30)
            ])),
            uf: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(2)
            ])),
            country: new FormControl('br', Validators.compose([
                Validators.required,
            ])),
        });
        return this.formCompanyAddress;
    }
    searchPostaCode(zipcode) {
        if (zipcode !== '' && zipcode !== null) {
            this.speNOpenAccountProxy
                .getCep(zipcode)
                .subscribe(data => this.updateAddress(data), error => this.errorMessageService.getError(error));
        }
    }
    getUf() {
        return this.ufService.getListUf();
    }
    sendCompanyAddress() {
        const preAccount = this.prepareCompanyAddress(this.formCompanyAddress);
        return this.speNOpenAccountProxy.updateCompanyAddress(this.keyPreAccount, preAccount);
    }
    updateForm() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            if (!!this.keyPreAccount) {
                this.getPreAccount(this.keyPreAccount);
            }
        });
    }
    getErrorCompanyAddress(error) {
        this.errorMessageService.getError(error);
    }
    getPreAccount(uuid) {
        this.keyPreAccount = uuid;
        this.speViewPreAccountProxy
            .findCompanyAddress(uuid)
            .subscribe(data => !!data.companyAddress ? this.syncForm(data.companyAddress) : null, err => this.errorMessageService.getError(err));
    }
    syncForm(companyAddress) {
        this.formCompanyAddress.patchValue({
            postalCode: companyAddress.postalCode,
            numberAddress: companyAddress.numberAddress,
            address: companyAddress.address,
            cityAddress: companyAddress.cityAddress,
            neighborhood: companyAddress.neighborhood,
            complementAddress: companyAddress.complementAddress,
            uf: companyAddress.uf,
            country: companyAddress.country
        });
    }
    updateAddress(address) {
        this.formCompanyAddress.patchValue({
            address: address.logradouro,
            neighborhood: address.bairro,
            cityAddress: address.localidade,
            uf: address.uf,
            country: 'br'
        });
    }
    prepareCompanyAddress(form) {
        const preAccountResponse = new PreAccountResponse();
        const companyAddress = new CompanyAddressResponse();
        const data = form.getRawValue();
        companyAddress.postalCode = data.postalCode;
        companyAddress.numberAddress = data.numberAddress;
        companyAddress.address = data.address;
        companyAddress.cityAddress = data.cityAddress;
        companyAddress.neighborhood = data.neighborhood;
        companyAddress.complementAddress = data.complementAddress;
        companyAddress.uf = data.uf;
        companyAddress.country = 'br';
        preAccountResponse._id = this.keyPreAccount;
        preAccountResponse.companyAddress = companyAddress;
        return preAccountResponse;
    }
};
CompanyAddressService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [Storage,
        FormBuilder,
        UfService,
        ConfigService,
        SpeNOpenAccountProxy,
        SpeViewPreAccountProxy,
        ErrorMessageService])
], CompanyAddressService);

class CompanyDataResponse {
}

let CompanyDataService = class CompanyDataService extends BaseService {
    constructor(storage, formBuilder, configService, speNOpenAccountProxy, speViewPreAccountProxy, errorMessageService) {
        super(storage, configService);
        this.storage = storage;
        this.formBuilder = formBuilder;
        this.configService = configService;
        this.speNOpenAccountProxy = speNOpenAccountProxy;
        this.speViewPreAccountProxy = speViewPreAccountProxy;
        this.errorMessageService = errorMessageService;
        this.errorMessages = {
            companyName: [
                { type: 'required', message: 'ONBORDING.COMPANY_DATA.FORM.COMPANY_NAME.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'ONBORDING.COMPANY_DATA.FORM.COMPANY_NAME.MESSAGE.MIN_LENGTH',
                    param: { minLength: 6 }
                },
                {
                    type: 'maxlength',
                    message: 'ONBORDING.COMPANY_DATA.FORM.COMPANY_NAME.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 100 }
                },
            ],
            manyPerson: [
                { type: 'required', message: 'ONBORDING.COMPANY_DATA.FORM.COMPANY_NAME.MESSAGE.REQUIRED' },
                {
                    type: 'min',
                    message: 'ONBORDING.COMPANY_DATA.FORM.COMPANY_NAME.MESSAGE.MIN_VALUE_PARTNER',
                    param: { minLength: 1 }
                },
            ],
            establishmentDate: [
                { type: 'required', message: 'ONBORDING.COMPANY_DATA.FORM.ESTABLISHMENT_DATE.MESSAGE.REQUIRED' },
                {
                    type: 'ptDate',
                    message: 'ONBORDING.COMPANY_DATA.FORM.ESTABLISHMENT_DATE.MESSAGE.DATE_NOT_VALID'
                },
                {
                    type: 'validDate',
                    message: 'ONBORDING.COMPANY_DATA.FORM.ESTABLISHMENT_DATE.MESSAGE.DATE_NOT_VALID'
                }
            ],
            turnoverAverage: [
                { type: 'required', message: 'ONBORDING.COMPANY_DATA.FORM.TURNOVER_AVERAGE.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'ONBORDING.COMPANY_DATA.FORM.COMPANY_NAME.MESSAGE.MIN_LENGTH',
                },
                {
                    type: 'min',
                    message: 'ONBORDING.COMPANY_DATA.FORM.COMPANY_NAME.MESSAGE.MIN_VALUE',
                    param: { minLength: 150 }
                }
            ],
            phone: [
                { type: 'required', message: 'ONBORDING.COMPANY_DATA.FORM.PHONE.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'ONBORDING.COMPANY_DATA.FORM.PHONE.MESSAGE.MIN_LENGTH',
                    param: { minLength: 15 },
                },
            ],
            cnaeCode: [
                { type: 'required', message: 'ONBORDING.COMPANY_DATA.FORM.CNAE_CODE.MESSAGE.REQUIRED' },
            ],
            cnaeDescription: [
                { type: 'required', message: 'ONBORDING.COMPANY_DATA.FORM.CNAE_DESCRIPTION.MESSAGE.REQUIRED' },
            ],
        };
        this.loadKey();
    }
    getErrorMessage() {
        return this.errorMessages;
    }
    getCompanyDataForm(isMEI) {
        this.companyDataForm = this.formBuilder.group({
            companyName: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(6),
                Validators.maxLength(100),
            ])),
            manyPerson: new FormControl('', Validators.compose([
                (!isMEI) ? Validators.required : null,
                Validators.min(1)
            ])),
            establishmentDate: new FormControl('', Validators.compose([
                Validators.required,
                DateValidator.ptDate,
                DateValidator.validDateMajor
            ])),
            turnoverAverage: new FormControl('R$ ', Validators.compose([
                Validators.required,
                /* Validators.minLength(6), */
                MoneyValidator.isValid,
                Validators.min(150)
            ])),
            phone: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(15),
            ])),
            cnaeCode: new FormControl('', Validators.compose([
                Validators.required
            ])),
            cnaeDescription: new FormControl('', Validators.compose([
                Validators.required
            ]))
        });
        return this.companyDataForm;
    }
    sendCompanyData() {
        const preAccount = this.prepareCompanyData(this.companyDataForm);
        return this.speNOpenAccountProxy.updateCompanyData(this.keyPreAccount, preAccount);
    }
    updateForm() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            if (!!this.keyPreAccount) {
                this.getPreAccount(this.keyPreAccount);
            }
        });
    }
    getErrorCompanyData(error) {
        this.errorMessageService.getError(error);
    }
    getPreAccount(uuid) {
        this.keyPreAccount = uuid;
        this.speViewPreAccountProxy
            .findCompanyData(uuid)
            .subscribe(data => {
            !!data.companyData ? this.syncForm(data.companyData) : null,
                this.typeFlow = data.accountType.typeFlow;
        }, err => this.errorMessageService.getError(err));
    }
    syncForm(companyData) {
        this.companyDataForm.patchValue({
            companyName: companyData.companyName,
            establishmentDate: companyData.establishmentDate,
            phone: companyData.phone,
            turnoverAverage: companyData.turnoverAverage,
            manyPerson: companyData.manyPerson,
            cnaeCode: companyData.cnaeCode,
            cnaeDescription: companyData.cnaeDescription,
        });
    }
    prepareCompanyData(form) {
        const preAccountResponse = new PreAccountResponse();
        const companyData = new CompanyDataResponse();
        const data = form.getRawValue();
        companyData.companyName = data.companyName;
        companyData.establishmentDate = data.establishmentDate;
        companyData.phone = data.phone;
        companyData.turnoverAverage = data.turnoverAverage;
        companyData.manyPerson = (!!data.manyPerson) ? data.manyPerson : null;
        companyData.cnaeCode = data.cnaeCode,
            companyData.cnaeDescription = data.cnaeDescription;
        preAccountResponse._id = this.keyPreAccount;
        preAccountResponse.companyData = companyData;
        return preAccountResponse;
    }
};
CompanyDataService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [Storage,
        FormBuilder,
        ConfigService,
        SpeNOpenAccountProxy,
        SpeViewPreAccountProxy,
        ErrorMessageService])
], CompanyDataService);

class ContractResponse {
}

let ContractService = class ContractService extends BaseService {
    constructor(formBuilder, speNOpenAccountProxy, speViewPreAccountProxy, storage, configService) {
        super(storage, configService);
        this.formBuilder = formBuilder;
        this.speNOpenAccountProxy = speNOpenAccountProxy;
        this.speViewPreAccountProxy = speViewPreAccountProxy;
        this.storage = storage;
        this.configService = configService;
    }
    getContractForm() {
        this.contractForm = this.formBuilder.group({
            acceptContract: false
        });
        return this.contractForm;
    }
    updateForm() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            if (!!this.keyPreAccount) {
                this.getPreAccount(this.keyPreAccount);
            }
        });
    }
    getPreAccount(uuid) {
        this.keyPreAccount = uuid;
        this.speViewPreAccountProxy
            .findContract(uuid)
            .subscribe(data => {
            return !!data.contract ? this.syncForm(data.contract) : null;
        });
    }
    syncForm(contract) {
        this.contractForm.patchValue({
            acceptContract: contract.acceptContract
        });
    }
    sendContract(form) {
        const contractData = this.prepareContract(form);
        return this.speNOpenAccountProxy.updatedContract(this.keyPreAccount, contractData);
    }
    prepareContract(form) {
        const preAccountRequest = new PreAccountResponse();
        const contractRequest = new ContractResponse();
        const data = form.getRawValue();
        contractRequest.acceptContract = data.acceptContract;
        contractRequest.dataAccept = new Date();
        preAccountRequest._id = this.keyPreAccount;
        preAccountRequest.contract = contractRequest;
        preAccountRequest.status = Status.IN_ANALYSIS_BACKOFFICE;
        return preAccountRequest;
    }
    getTerms() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            const _id = this.keyPreAccount;
            return this.speViewPreAccountProxy.getTerm(_id).toPromise();
        });
    }
    getTermByuuid(uuid) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.speViewPreAccountProxy.getTermByuuid(uuid);
        });
    }
    getTermsByPreAccount(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.speViewPreAccountProxy.getTerm(id);
        });
    }
    sendContractV2(data) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            const _id = this.keyPreAccount;
            return this.speNOpenAccountProxy.sendContract(_id, data).toPromise();
        });
    }
    getPartnersContract() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            const _id = this.keyPreAccount;
            return this.speViewPreAccountProxy.getPartnersContract(_id);
        });
    }
    getStatusPartnersContractSteps(id, idPartner) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.speViewPreAccountProxy.getStatusPartnersContractSteps(id, idPartner).toPromise();
        });
    }
    sendEmailContractPartners() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            const _id = this.keyPreAccount;
            return this.speNOpenAccountProxy.sendEmailContractPartners(_id).toPromise();
        });
    }
};
ContractService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [FormBuilder,
        SpeNOpenAccountProxy,
        SpeViewPreAccountProxy,
        Storage,
        ConfigService])
], ContractService);

let CreateAccountService = class CreateAccountService extends BaseService {
    constructor(formBuilder, speNOpenAccountProxy, speViewPreAccountProxy, storage, configService, errorMessageService, authUtilBase) {
        super(storage, configService);
        this.formBuilder = formBuilder;
        this.speNOpenAccountProxy = speNOpenAccountProxy;
        this.speViewPreAccountProxy = speViewPreAccountProxy;
        this.storage = storage;
        this.configService = configService;
        this.errorMessageService = errorMessageService;
        this.authUtilBase = authUtilBase;
        this.errorMessages = {
            name: [
                { type: 'required', message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.FULLNAME.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.FULLNAME.MESSAGE.MIN_LENGTH',
                    param: { minLength: 5 },
                },
                {
                    type: 'maxlength',
                    message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.FULLNAME.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 60 },
                },
                { type: 'pattern', message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.FULLNAME.MESSAGE.PATTERN' },
            ],
            document: [
                { type: 'required', message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.CPF.MESSAGE.REQUIRED' },
                { type: 'cpfNotValid', message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.CPF.MESSAGE.CPF_NOT_VALID' },
                { type: 'cnpjNotValid', message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.CPF.MESSAGE.CPF_NOT_VALID' },
            ],
            email: [
                { type: 'required', message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.E_MAIL.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.E_MAIL.MESSAGE.MIN_LENGTH',
                    param: { minLength: 6 },
                },
                {
                    type: 'maxlength',
                    message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.E_MAIL.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 60 },
                },
                { type: 'pattern', message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.E_MAIL.MESSAGE.PATTERN' },
            ],
            phone: [
                { type: 'required', message: 'ONBORDING.COMPANY_DATA.FORM.PHONE.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'ONBORDING.COMPANY_DATA.FORM.PHONE.MESSAGE.MIN_LENGTH',
                    param: { minLength: 15 },
                },
            ],
        };
    }
    getFormMessageError() {
        return this.errorMessages;
    }
    createFormToUnicoFlow(isPF, pfOwnerPersonalData) {
        this.formCreateAccount = this.formBuilder.group({
            name: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(5),
                Validators.maxLength(60),
                isPF
                    ? Validators.pattern("^([a-zà-úA-ZÀ-Ú]{2,}\\s?([a-zà-úA-ZÀ-Ú]{1,})?\\s[a-zà-úA-ZÀ-Ú]{1,}'?-?[a-zà-úA-ZÀ-Ú]{1,}\\s?([a-zà-úA-ZÀ-Ú]{1,})?\\s?([a-zà-úA-ZÀ-Ú]{1,})?\\s?([a-zà-úA-ZÀ-Ú]{1,})?\\s?([a-zà-úA-ZÀ-Ú]{1,})?)")
                    : null,
            ])),
            document: new FormControl('', Validators.compose([Validators.required, DocumentValidator.isValidCPFCNPJ])),
            email: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(6),
                Validators.maxLength(60),
                Validators.pattern('[a-z0-9._%+-]{2,}@[a-z0-9.-]{2,}\\.[a-z]{2,5}'),
            ])),
            phone: new FormControl('', Validators.compose([Validators.required, Validators.minLength(15)])),
            birthDay: new FormControl('', Validators.compose(isPF ? [Validators.required, DateValidator.ptDate, DateValidator.validDate] : null)),
        });
        return this.formCreateAccount;
    }
    formatDate(date) {
        const dateFull = new Date(date);
        const day = dateFull.getDate().toString(), dayF = day.length == 1 ? '0' + day : day, month = (dateFull.getMonth() + 1).toString(), monthF = month.length == 1 ? '0' + month : month, year = dateFull.getFullYear();
        return dayF + '/' + monthF + '/' + year;
    }
    createForm(isPF) {
        this.formCreateAccount = this.formBuilder.group({
            name: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(5),
                Validators.maxLength(60),
                isPF
                    ? Validators.pattern("^([a-zà-úA-ZÀ-Ú]{2,}\\s?([a-zà-úA-ZÀ-Ú]{1,})?\\s[a-zà-úA-ZÀ-Ú]{1,}'?-?[a-zà-úA-ZÀ-Ú]{1,}\\s?([a-zà-úA-ZÀ-Ú]{1,})?\\s?([a-zà-úA-ZÀ-Ú]{1,})?\\s?([a-zà-úA-ZÀ-Ú]{1,})?\\s?([a-zà-úA-ZÀ-Ú]{1,})?)")
                    : null,
            ])),
            document: new FormControl('', Validators.compose([Validators.required, DocumentValidator.isValidCPFCNPJ])),
            email: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(6),
                Validators.maxLength(60),
                Validators.pattern('[a-z0-9._%+-]{2,}@[a-z0-9.-]{2,}\\.[a-z]{2,5}'),
            ])),
            // emailConfirm: new FormControl(''),
            phone: new FormControl('', Validators.compose([Validators.required, Validators.minLength(15)])),
        });
        return this.formCreateAccount;
    }
    createPreAccount(form, uuidWhiteLabel, nextStep) {
        let preAccountResponse = this.preparePreAccount(form, uuidWhiteLabel, nextStep);
        if (this.keyPreAccount) {
            return this.speNOpenAccountProxy.updatePreAccount(this.keyPreAccount, preAccountResponse);
        }
        return this.speNOpenAccountProxy.createPreAccount(preAccountResponse);
    }
    updateStatus(preAccount) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            preAccount._id = this.keyPreAccount;
            return yield this.speNOpenAccountProxy.updateStatus(this.keyPreAccount, preAccount).toPromise();
        });
    }
    processPreAccount(preAccount) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.addItem(this.configService.getKeyForm(), preAccount._id);
        });
    }
    updateForm() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            if (!!this.keyPreAccount) {
                this.getPreAccount(this.keyPreAccount);
            }
        });
    }
    findAccountTypeByUuid(uuid) {
        return this.speViewPreAccountProxy.findAccountType(uuid);
    }
    getPreAccount(uuid) {
        this.speViewPreAccountProxy.findPreAccount(uuid).subscribe((data) => (!!data ? this.syncForm(data, uuid) : null), (err) => this.errorMessageService.getError(err));
    }
    syncForm(preAccount, keyPreAccount) {
        this.keyPreAccount = keyPreAccount;
        this.formCreateAccount.patchValue({
            name: preAccount.name,
            document: preAccount.document,
            // rg: preAccount.rg,
            email: preAccount.email,
            phone: preAccount.phone,
        });
    }
    preparePreAccount(form, uuidWhiteLabel, nextStep) {
        const preAccount = new PreAccountResponse();
        let data = form.getRawValue();
        preAccount._id = this.keyPreAccount;
        preAccount.uuidWhiteLabel = uuidWhiteLabel;
        preAccount.name = data.fullname;
        preAccount.cpf = data.cpf;
        preAccount.rg = data.rg;
        preAccount.email = data.email;
        preAccount.status = Status.IN_ONBORDING;
        preAccount.lastStep = nextStep;
        preAccount.personalData.birthDay = data.birthDay;
        return preAccount;
    }
    getErrorPreAccount(error) {
        this.errorMessageService.getError(error);
    }
    checkAccountExists(uuidWhiteLabel, cpf) {
        return this.speNOpenAccountProxy.findByWhiteLabelAndCpf(uuidWhiteLabel, cpf);
    }
    // Method finds accounts by document to retry onboarding
    findAccountsForRetryOnboarding(data) {
        return this.speNOpenAccountProxy.findAccountsForRetryOnboarding(data);
    }
    verifyEmailByIdAndIdwl(id, email, uuidWhiteLabel) {
        return this.speViewPreAccountProxy.findEmailByIdAndEmailAndWhiteLabel(id, uuidWhiteLabel, email);
    }
    verifyEmailByCpfAndIdwl(cpf, email, uuidWhiteLabel) {
        return this.speViewPreAccountProxy.findEmailByCpfAndEmailAndWhiteLabel(cpf, uuidWhiteLabel, email);
    }
    verifyEmailByIdwl(email, uuidWhiteLabel) {
        return this.speViewPreAccountProxy.findEmailByEmailAndWhiteLabel(email, uuidWhiteLabel);
    }
    loadPreAccount(uuid) {
        return this.speViewPreAccountProxy.findPreAccount(uuid).toPromise();
    }
    getLoadKeyPreAccount() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            return this.keyPreAccount;
        });
    }
    documentAccount(document, accountType, uuidWhiteLabel, nickname, platformVersion, platformType) {
        let platformAllInfo = this.authUtilBase.getAllPlatformInfo();
        if (!platformType) {
            platformType = 'WEB';
        }
        platformType = `${platformType} (${platformAllInfo})`;
        const data = {
            document,
            accountType,
            uuidWhiteLabel,
            nickname,
            platformVersion,
            platformType,
        };
        return this.speNOpenAccountProxy.documentAccount(data);
    }
    dataAccount(form, platformVersion, platformType, callBackUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            let platformAllInfo = this.authUtilBase.getAllPlatformInfo();
            if (!platformType) {
                platformType = 'WEB';
            }
            platformType = `${platformType} (${platformAllInfo})`;
            yield this.loadKey();
            const _id = this.keyPreAccount;
            const data = Object.assign({ _id,
                platformVersion,
                platformType }, form, { callBackUrl });
            console.log(data);
            return yield this.speNOpenAccountProxy.dataAccount(data).toPromise();
        });
    }
    validationCode(id, type, formSendCode) {
        const dataRawValue = formSendCode.getRawValue();
        const codeDeviceValidation = `${dataRawValue.codeNumberOne}${dataRawValue.codeNumberTwo}${dataRawValue.codeNumberThree}${dataRawValue.codeNumberFour}${dataRawValue.codeNumberFive}`;
        const data = {
            id,
            code: codeDeviceValidation,
            type,
        };
        return this.speNOpenAccountProxy.validationCode(data);
    }
    resendCode(id, platformVersion, platformType) {
        if (!platformType) {
            platformType = 'WEB';
        }
        const data = {
            id,
            platformVersion,
            platformType,
        };
        return this.speNOpenAccountProxy.resendCode(data);
    }
    sendCode(id, type, step) {
        const data = {
            id,
            type,
            step,
        };
        return this.speNOpenAccountProxy.sendCode(data);
    }
    prepareFormValidation(data) {
        if (data) {
            this.formCreateAccount.patchValue({
                name: data.name,
                document: data.document,
                email: data.email,
                phone: data.phone,
                birthDay: this.formatDate(data.birthDay)
            });
        }
        else {
            this.formCreateAccount.patchValue({
                name: null,
                email: null,
                phone: null,
            });
        }
    }
    validationEmailLink(validation) {
        return this.speNOpenAccountProxy.linkValidatoinEmail(validation);
    }
    findPreAccount(uuid) {
        return this.speViewPreAccountProxy.findPreAccount(uuid).toPromise();
    }
    finishOnboarding() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            let preAccountToUpdate;
            this.speNOpenAccountProxy.getPreAccount(this.keyPreAccount).subscribe(res => {
                preAccountToUpdate = res;
                preAccountToUpdate.status = Status.IN_ANALYSIS_BACKOFFICE;
                this.speNOpenAccountProxy.updateStatus(preAccountToUpdate._id, preAccountToUpdate).subscribe(res => console.log(res));
            }, err => console.log(err));
        });
    }
};
CreateAccountService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [FormBuilder,
        SpeNOpenAccountProxy,
        SpeViewPreAccountProxy,
        Storage,
        ConfigService,
        ErrorMessageService,
        AuthUtilBase])
], CreateAccountService);

let PartnersService = class PartnersService extends BaseService {
    constructor(formBuilder, speNOpenAccountProxy, speViewPreAccountProxy, storage, configService, errorMessageService) {
        super(storage, configService);
        this.formBuilder = formBuilder;
        this.speNOpenAccountProxy = speNOpenAccountProxy;
        this.speViewPreAccountProxy = speViewPreAccountProxy;
        this.storage = storage;
        this.configService = configService;
        this.errorMessageService = errorMessageService;
        this.errorMessages = {
            fullname: [
                { type: 'required', message: 'ONBORDING.ADD_PARTNERS.FORM.FULLNAME.MESSAGE.REQUIRED' },
                {
                    type: 'minlength', message: 'ONBORDING.ADD_PARTNERS.FORM.FULLNAME.MESSAGE.MIN_LENGTH',
                    param: { minLength: 6 }
                },
                {
                    type: 'maxlength', message: 'ONBORDING.ADD_PARTNERS.FORM.FULLNAME.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 100 }
                },
                { type: 'pattern', message: 'ONBORDING.ADD_PARTNERS.FORM.FULLNAME.MESSAGE.PATTERN' },
            ],
            docNumber: [
                { type: 'required', message: 'ONBORDING.ADD_PARTNERS.FORM.CPF.MESSAGE.REQUIRED' },
                { type: 'cpfNotValid', message: 'ONBORDING.ADD_PARTNERS.FORM.CPF.MESSAGE.CPF_NOT_VALID' }
            ],
            phone: [
                { type: 'required', message: 'ONBORDING.COMPANY_DATA.FORM.PHONE.MESSAGE.REQUIRED' },
            ],
            email: [
                { type: 'required', message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.E_MAIL.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.E_MAIL.MESSAGE.MIN_LENGTH',
                    param: { minLength: 6 },
                },
                {
                    type: 'maxlength',
                    message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.E_MAIL.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 60 },
                },
                { type: 'pattern', message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.E_MAIL.MESSAGE.PATTERN' },
            ],
        };
        this.businessPartnerList = [];
        this.behaviorList = new BehaviorSubject([]);
        this.status = new BehaviorSubject(null);
    }
    getErrorBusinessPartner(error) {
        this.errorMessageService.getError(error);
    }
    updateForm() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            if (this.keyPreAccount != null) {
                this.getPreAccount(this.keyPreAccount);
            }
        });
    }
    getPreAccount(uuid) {
        this.speViewPreAccountProxy
            .findPartners(uuid)
            .pipe(tap(data => {
            this.preAccountBody = data;
            if (data.businessPartner !== undefined && data.businessPartner.length > 0) {
                this.businessPartnerList = data.businessPartner;
                this.behaviorList.next(this.businessPartnerList);
            }
            else {
                this.includeFirstPartner(data);
            }
        }), catchError(res => {
            this.errorMessageService.getError(res);
            return of(false);
        }))
            .subscribe();
    }
    getListPartners() {
        return this.speNOpenAccountProxy.getPartners(this.keyPreAccount)
            .pipe(map(arr => arr.businessPartner)).toPromise();
    }
    getStatus() {
        return this.status;
    }
    includeFirstPartner(preAccount) {
        this.preAccountBody = preAccount;
        const businessPartnerObj = new BusinessPartnerResponse();
        businessPartnerObj.fullname = preAccount.name;
        businessPartnerObj.docNumber = preAccount.cpf;
        businessPartnerObj.phone = preAccount.phone;
        businessPartnerObj.email = preAccount.email;
        businessPartnerObj.partnerPercentage = preAccount.partnerPercentage;
        businessPartnerObj.legalRepresentative = false;
        businessPartnerObj.attorney = false;
        businessPartnerObj.partner = false;
        businessPartnerObj.master = true;
        businessPartnerObj.signature = true;
        this.businessPartnerList.push(businessPartnerObj);
        this.preAccountBody.businessPartner = this.businessPartnerList;
        return this.sendBusinessPartner(this.preAccountBody);
    }
    editForm(businessPartner) {
        this.formBusinessPartner.patchValue({
            fullname: businessPartner.fullname,
            docNumber: businessPartner.docNumber,
            phone: businessPartner.phone,
            email: businessPartner.email,
            legalRepresentative: businessPartner.legalRepresentative,
            attorney: businessPartner.attorney,
            partner: businessPartner.partner,
            master: businessPartner.master,
            signature: businessPartner.signature,
            partnerPercentage: businessPartner.partnerPercentage
        });
        return this.formBusinessPartner;
    }
    getFormBusinessPartner() {
        this.formBusinessPartner = this.formBuilder.group({
            fullname: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(6),
                Validators.maxLength(100),
                Validators.pattern("^([a-zà-úA-ZÀ-Ú]{2,}\\s?([a-zà-úA-ZÀ-Ú]{1,})?\\s[a-zà-úA-ZÀ-Ú]{1,}'?-?[a-zà-úA-ZÀ-Ú]{1,}\\s?([a-zà-úA-ZÀ-Ú]{1,})?\\s?([a-zà-úA-ZÀ-Ú]{1,})?\\s?([a-zà-úA-ZÀ-Ú]{1,})?\\s?([a-zà-úA-ZÀ-Ú]{1,})?)")
            ])),
            docNumber: new FormControl('', Validators.compose([
                Validators.required,
                DocumentValidator.isValidCPF
            ])),
            phone: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(15)
            ])),
            email: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(6),
                Validators.maxLength(60),
                Validators.pattern('[a-z0-9._%+-]{2,}@[a-z0-9.-]{2,}\\.[a-z]{2,5}')
            ])),
            partnerPercentage: new FormControl(0),
            legalRepresentative: false,
            attorney: false,
            partner: false,
            master: false,
            signature: false
        });
        return this.formBusinessPartner;
    }
    getFormMessageError() {
        return this.errorMessages;
    }
    addNewPartner(form) {
        const partnerItem = form.getRawValue();
        const businessPartnerResponse = new BusinessPartnerResponse();
        businessPartnerResponse.fullname = partnerItem.fullname;
        businessPartnerResponse.docNumber = partnerItem.docNumber;
        businessPartnerResponse.email = partnerItem.email;
        businessPartnerResponse.phone = partnerItem.phone;
        businessPartnerResponse.legalRepresentative = partnerItem.legalRepresentative;
        businessPartnerResponse.attorney = partnerItem.attorney;
        businessPartnerResponse.partner = partnerItem.partner;
        businessPartnerResponse.master = partnerItem.master;
        businessPartnerResponse.signature = partnerItem.signature;
        businessPartnerResponse.partnerPercentage = partnerItem.partnerPercentage;
        this.preAccountBody.businessPartner.push(businessPartnerResponse);
        return this.sendBusinessPartner(this.preAccountBody);
    }
    editPartner(form, index) {
        const partnerItem = form.getRawValue();
        const businessPartnerResponse = new BusinessPartnerResponse();
        businessPartnerResponse.fullname = partnerItem.fullname;
        businessPartnerResponse.docNumber = partnerItem.docNumber;
        businessPartnerResponse.email = partnerItem.email;
        businessPartnerResponse.phone = partnerItem.phone;
        businessPartnerResponse.legalRepresentative = partnerItem.legalRepresentative;
        businessPartnerResponse.attorney = partnerItem.attorney;
        businessPartnerResponse.partner = partnerItem.partner;
        businessPartnerResponse.master = partnerItem.master;
        businessPartnerResponse.signature = partnerItem.signature;
        businessPartnerResponse.partnerPercentage = partnerItem.partnerPercentage;
        this.preAccountBody.businessPartner.splice(index, 1, businessPartnerResponse);
        this.sendBusinessPartner(this.preAccountBody);
    }
    removePartner(index) {
        this.preAccountBody.businessPartner.splice(index, 1);
        return this.sendBusinessPartner(this.preAccountBody);
    }
    sendBusinessPartner(preAccount) {
        if (preAccount.businessPartner && preAccount.businessPartner.length > 0 && preAccount.businessPartner[0].id) {
            this.status.next(true);
            this.speNOpenAccountProxy.updateBusinessPartner(this.keyPreAccount, preAccount)
                .pipe(tap(res => {
                this.behaviorList.next(res.businessPartner);
                this.status.next(false);
            }), catchError(res => {
                this.status.next(false);
                return of(false);
            }))
                .subscribe();
        }
    }
    initializeBehaviourList() {
        this.behaviorList = new BehaviorSubject([]);
        this.status = new BehaviorSubject(null);
        this.businessPartnerList = [];
    }
};
PartnersService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [FormBuilder,
        SpeNOpenAccountProxy,
        SpeViewPreAccountProxy,
        Storage,
        ConfigService,
        ErrorMessageService])
], PartnersService);

class AddressDataResponse {
}

let PersonalAddressService = class PersonalAddressService extends BaseService {
    constructor(storage, ufService, formBuilder, configService, speNOpenAccountProxy, speViewPreAccountProxy, errorMessageService) {
        super(storage, configService);
        this.storage = storage;
        this.ufService = ufService;
        this.formBuilder = formBuilder;
        this.configService = configService;
        this.speNOpenAccountProxy = speNOpenAccountProxy;
        this.speViewPreAccountProxy = speViewPreAccountProxy;
        this.errorMessageService = errorMessageService;
        this.formErrorMessages = {
            postalCode: [
                { type: 'required', message: 'ONBORDING.ADDRESS_MASTER.FORM.POSTALCODE.MESSAGE.REQUIRED' },
                { type: 'minlength', message: 'ONBORDING.ADDRESS_MASTER.FORM.POSTALCODE.MESSAGE.MIN_LENGTH', param: { minLength: 9 } },
                { type: 'pattern', message: 'ONBORDING.ADDRESS_MASTER.FORM.POSTALCODE.MESSAGE.PATTERN' }
            ],
            address: [
                { type: 'required', message: 'ONBORDING.ADDRESS_MASTER.FORM.ADDRESS.MESSAGE.REQUIRED' },
                { type: 'minlength', param: { minLength: 3 }, message: 'ONBORDING.ADDRESS_MASTER.FORM.ADDRESS.MESSAGE.MIN_LENGTH' },
                { type: 'maxlength', param: { maxLength: 200 }, message: 'ONBORDING.ADDRESS_MASTER.FORM.ADDRESS.MESSAGE.MAX_LENGTH' },
            ],
            numberAddress: [
                { type: 'required', message: 'ONBORDING.ADDRESS_MASTER.FORM.NUMBER_ADDRESS.MESSAGE.REQUIRED' },
                { type: 'maxlength', param: { maxLength: 5 }, message: 'ONBORDING.ADDRESS_MASTER.FORM.NUMBER_ADDRESS.MESSAGE.MAX_LENGTH' },
            ],
            complementAddress: [
                { type: 'maxlength', param: { maxLength: 60 }, message: 'ONBORDING.ADDRESS_MASTER.FORM.COMPLEMENT_ADDRESS.MESSAGE.MAX_LENGTH' }
            ],
            neighborhood: [
                { type: 'required', message: 'ONBORDING.ADDRESS_MASTER.FORM.NEIGHBORHOOD.MESSAGE.REQUIRED' },
                { type: 'minlength', param: { minLength: 3 }, message: 'ONBORDING.ADDRESS_MASTER.FORM.NEIGHBORHOOD.MESSAGE.MIN_LENGTH' },
                { type: 'maxlength', param: { maxLength: 60 }, message: 'ONBORDING.ADDRESS_MASTER.FORM.NEIGHBORHOOD.MESSAGE.MAX_LENGTH' }
            ],
            cityAddress: [
                { type: 'required', message: 'ONBORDING.ADDRESS_MASTER.FORM.CITY_ADDRESS.MESSAGE.REQUIRED' },
                { type: 'minlength', param: { minLength: 3 }, message: 'ONBORDING.ADDRESS_MASTER.FORM.CITY_ADDRESS.MESSAGE.MIN_LENGTH' },
                { type: 'maxlength', param: { maxLength: 30 }, message: 'ONBORDING.ADDRESS_MASTER.FORM.CITY_ADDRESS.MESSAGE.MAX_LENGTH' }
            ],
            uf: [
                { type: 'required', message: 'ONBORDING.ADDRESS_MASTER.FORM.UF.MESSAGE.REQUIRED' }
            ],
            country: [
            // { type: 'required', message: 'Campo obrigatório' },
            ],
        };
    }
    getFormErrorMessage() {
        return this.formErrorMessages;
    }
    getFormPersonalAddress() {
        this.formPersonalAddress = this.formBuilder.group({
            postalCode: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(9),
                Validators.pattern('^[a-zA-Z0-9_.+-]+$')
            ])),
            address: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(3),
                Validators.maxLength(200),
            ])),
            numberAddress: new FormControl('', Validators.compose([
                Validators.required,
                Validators.maxLength(30),
            ])),
            complementAddress: new FormControl('', Validators.compose([
                Validators.maxLength(60),
            ])),
            neighborhood: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(3),
                Validators.maxLength(60)
            ])),
            cityAddress: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(3),
                Validators.maxLength(30)
            ])),
            uf: new FormControl('', Validators.compose([
                Validators.required
            ])),
            country: new FormControl('br', Validators.compose([
                Validators.required,
                Validators.minLength(2),
            ])),
        });
        return this.formPersonalAddress;
    }
    searchPostaCode(zipcode) {
        if (zipcode !== '' && zipcode !== null) {
            this.speNOpenAccountProxy
                .getCep(zipcode)
                .subscribe(data => this.updateAddress(data), error => this.errorMessageService.getError(error));
        }
    }
    sendPersonalAddress() {
        const preAccount = this.preparePersonalAddress(this.formPersonalAddress);
        return this.speNOpenAccountProxy.updateAddressData(this.keyPreAccount, preAccount);
    }
    updateForm() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            if (!!this.keyPreAccount) {
                this.getPreAccount(this.keyPreAccount);
            }
        });
    }
    getErrorPersonalAddress(error) {
        this.errorMessageService.getError(error);
    }
    getUf() {
        return this.ufService.getListUf();
    }
    getPreAccount(uuid) {
        this.keyPreAccount = uuid;
        this.speViewPreAccountProxy
            .findPersonalAddress(uuid)
            .subscribe(data => !!data.addressData ? this.syncForm(data.addressData) : null, err => this.errorMessageService.getError(err));
    }
    syncForm(addressData) {
        this.formPersonalAddress.patchValue({
            postalCode: addressData.cep,
            cityAddress: addressData.city,
            address: addressData.street,
            neighborhood: addressData.neighborhood,
            complementAddress: addressData.streetComplement,
            numberAddress: addressData.streetNumber,
            uf: addressData.uf,
            country: addressData.country
        });
    }
    updateAddress(address) {
        this.formPersonalAddress.patchValue({
            address: address.logradouro,
            neighborhood: address.bairro,
            cityAddress: address.localidade,
            uf: address.uf,
            country: 'br'
        });
    }
    preparePersonalAddress(form) {
        const preAccountResponse = new PreAccountResponse();
        const addressData = new AddressDataResponse();
        const data = form.getRawValue();
        addressData.cep = data.postalCode;
        addressData.city = data.cityAddress;
        addressData.street = data.address;
        addressData.neighborhood = data.neighborhood;
        addressData.streetComplement = data.complementAddress;
        addressData.streetNumber = data.numberAddress;
        addressData.uf = data.uf;
        addressData.country = 'br';
        preAccountResponse._id = this.keyPreAccount;
        preAccountResponse.addressData = addressData;
        return preAccountResponse;
    }
};
PersonalAddressService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [Storage,
        UfService,
        FormBuilder,
        ConfigService,
        SpeNOpenAccountProxy,
        SpeViewPreAccountProxy,
        ErrorMessageService])
], PersonalAddressService);

class PersonalDataResponse {
}

let PersonalDataService = class PersonalDataService extends BaseService {
    constructor(formBuilder, speNOpenAccountProxy, speViewPreAccountProxy, storage, configService, errorMessageService, maskService, accountService) {
        super(storage, configService);
        this.formBuilder = formBuilder;
        this.speNOpenAccountProxy = speNOpenAccountProxy;
        this.speViewPreAccountProxy = speViewPreAccountProxy;
        this.storage = storage;
        this.configService = configService;
        this.errorMessageService = errorMessageService;
        this.maskService = maskService;
        this.accountService = accountService;
        this.errorFormMessages = {
            rg: [
                { type: 'required', message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.RG.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.RG.MESSAGE.MIN_LENGTH',
                    param: { minLength: 4 },
                },
                {
                    type: 'maxlength',
                    message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.RG.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 14 },
                },
            ],
            motherFullname: [
                { type: 'required', message: 'ONBORDING.DATA_MASTER.FORM.MOTHER_FULLNAME.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'ONBORDING.DATA_MASTER.FORM.MOTHER_FULLNAME.MESSAGE.MIN_LENGTH',
                    param: { minLength: 6 },
                },
                {
                    type: 'maxlength',
                    message: 'ONBORDING.DATA_MASTER.FORM.MOTHER_FULLNAME.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 50 },
                },
            ],
            birthDate: [
                { type: 'required', message: 'ONBORDING.DATA_MASTER.FORM.BIRTHDATE.MESSAGE.REQUIRED' },
                {
                    type: 'validatesMajority',
                    message: 'ONBORDING.DATA_MASTER.FORM.BIRTHDATE.MESSAGE.MAJORITY_DATE',
                },
                {
                    type: 'validDate',
                    message: 'ONBORDING.DATA_MASTER.FORM.BIRTHDATE.MESSAGE.DATE_NOT_VALID',
                },
                {
                    type: 'ptDate',
                    message: 'ONBORDING.DATA_MASTER.FORM.BIRTHDATE.MESSAGE.DATE_NOT_VALID',
                },
            ],
            monthlyIncome: [
                { type: 'required', message: 'ONBORDING.DATA_MASTER.FORM.MONTHLY_INCOME.MESSAGE.REQUIRED' },
                {
                    type: 'minSalaryValue',
                    message: 'ONBORDING.DATA_MASTER.FORM.MONTHLY_INCOME.MESSAGE.MIN_VALUE_INFORMED',
                    param: { minValue: 300 },
                },
                {
                    type: 'minlength',
                    message: 'ONBORDING.DATA_MASTER.FORM.MONTHLY_INCOME.MESSAGE.MIN_LENGTH',
                    param: { minLength: 6 },
                },
            ],
            marital: [{ type: 'required', message: 'ONBORDING.DATA_MASTER.FORM.MARITAL.MESSAGE.REQUIRED' }],
        };
    }
    getPersonalData() {
        this.formPersonalData = this.formBuilder.group({
            motherFullname: new FormControl('', Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(50)])),
            birthDate: new FormControl('', Validators.compose([Validators.required, DateValidator.ptDate, DateValidator.validatesMajority])),
            monthlyIncome: new FormControl('', Validators.compose([Validators.required, MoneyValidator.isValid, minOrEqualValueValidator()])),
            marital: new FormControl('', Validators.compose([Validators.required])),
            rg: new FormControl('', Validators.compose([Validators.required, Validators.minLength(4), Validators.maxLength(20)])),
        });
        return this.formPersonalData;
    }
    getFormErrorMessage() {
        return this.errorFormMessages;
    }
    sendPersonalData(form, nextStep) {
        const personalData = this.preparePersonalData(form);
        personalData.lastStep = nextStep;
        return this.speNOpenAccountProxy.updatePersonalData(this.keyPreAccount, personalData);
    }
    getErrorPersonalData(error) {
        this.errorMessageService.getError(error);
    }
    updateForm() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            if (!!this.keyPreAccount) {
                this.getPreAccount(this.keyPreAccount);
            }
        });
    }
    applyMaskCurrency(controlName, form) {
        this.maskService.currency(controlName, form);
    }
    getPreAccount(uuid) {
        this.keyPreAccount = uuid;
        this.speViewPreAccountProxy.findPersonalData(uuid).subscribe((data) => (!!data.personalData ? this.syncForm(data.personalData) : null), (err) => this.errorMessageService.getError(err));
    }
    syncForm(personalData) {
        this.formPersonalData.patchValue({
            rg: personalData.rg,
            birthDate: personalData.birthDay,
            marital: personalData.marital,
            motherFullname: personalData.motherName,
            monthlyIncome: personalData.monthlyIncome.toFixed(2),
        });
    }
    preparePersonalData(form) {
        const preAccountResponse = new PreAccountResponse();
        const personalDataResponse = new PersonalDataResponse();
        const data = form.getRawValue();
        personalDataResponse.birthDay = data.birthDate;
        personalDataResponse.marital = data.marital;
        personalDataResponse.motherName = data.motherFullname;
        personalDataResponse.rg = data.rg;
        personalDataResponse.monthlyIncome = this.formatValue(data.monthlyIncome);
        preAccountResponse._id = this.keyPreAccount;
        preAccountResponse.personalData = personalDataResponse;
        return preAccountResponse;
    }
    formatValue(value) {
        const value2 = value.replace('R$', '', value.monthlyIncome);
        let monthlyValue = value2.replace(',', '.');
        return parseFloat(monthlyValue);
    }
};
PersonalDataService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [FormBuilder,
        SpeNOpenAccountProxy,
        SpeViewPreAccountProxy,
        Storage,
        ConfigService,
        ErrorMessageService,
        MaskService,
        AccountTypeService])
], PersonalDataService);

class ProfessionalTypeResponse {
}

let ProfessionalTypeService = class ProfessionalTypeService extends BaseService {
    constructor(storage, certifiedService, formBuilder, configService, speNOpenAccountProxy, speViewPreAccountProxy, errorMessageService) {
        super(storage, configService);
        this.storage = storage;
        this.certifiedService = certifiedService;
        this.formBuilder = formBuilder;
        this.configService = configService;
        this.speNOpenAccountProxy = speNOpenAccountProxy;
        this.speViewPreAccountProxy = speViewPreAccountProxy;
        this.errorMessageService = errorMessageService;
        this.errorMessages = {
            certifiedType: [
                { type: 'required', message: 'ONBORDING.PROFESSIONAL_TYPE.FORM.CERTIFIED_TYPE.MESSAGE.REQUIRED' },
            ],
            certifiedNumber: [
                { type: 'required', message: 'ONBORDING.PROFESSIONAL_TYPE.FORM.CERTIFIED_NUMBER.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'ONBORDING.PROFESSIONAL_TYPE.FORM.CERTIFIED_NUMBER.MESSAGE.MIN_LENGTH',
                    param: { minLength: 4 }
                },
                {
                    type: 'maxlength',
                    message: 'ONBORDING.PROFESSIONAL_TYPE.FORM.CERTIFIED_NUMBER.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 20 }
                },
            ]
        };
    }
    getErrorMessage() {
        return this.errorMessages;
    }
    getProfessionalTypeForm() {
        this.professionalTypeForm = this.formBuilder.group({
            certifiedType: new FormControl('', Validators.compose([
                Validators.required,
            ])),
            certifiedNumber: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(4),
                Validators.maxLength(20),
            ])),
        });
        return this.professionalTypeForm;
    }
    sendProfessionalType() {
        const preAccount = this.prepareProfessionalType(this.professionalTypeForm);
        return this.speNOpenAccountProxy.updateProfessionalType(this.keyPreAccount, preAccount);
    }
    updateForm() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            if (!!this.keyPreAccount) {
                this.getPreAccount(this.keyPreAccount);
            }
        });
    }
    getErrorProfessionalType(error) {
        this.errorMessageService.getError(error);
    }
    getCertified() {
        return this.certifiedService.getListCertified();
    }
    getPreAccount(uuid) {
        this.speViewPreAccountProxy
            .findProfessionalType(uuid)
            .subscribe(data => !!data.professionalType ? this.syncForm(data.professionalType) : null, err => this.errorMessageService.getError(err));
    }
    syncForm(professionalType) {
        this.professionalTypeForm.patchValue({
            certifiedType: professionalType.certifiedType,
            certifiedNumber: professionalType.certifiedNumber,
        });
    }
    prepareProfessionalType(form) {
        const preAccountResponse = new PreAccountResponse();
        const professionalType = new ProfessionalTypeResponse();
        const data = form.getRawValue();
        professionalType.certifiedType = data.certifiedType;
        professionalType.certifiedNumber = data.certifiedNumber;
        preAccountResponse._id = this.keyPreAccount;
        preAccountResponse.professionalType = professionalType;
        return preAccountResponse;
    }
};
ProfessionalTypeService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [Storage,
        CertifiedService,
        FormBuilder,
        ConfigService,
        SpeNOpenAccountProxy,
        SpeViewPreAccountProxy,
        ErrorMessageService])
], ProfessionalTypeService);

let ResponsibleMeiService = class ResponsibleMeiService extends BaseService {
    constructor(formBuilder, speNOpenAccountProxy, speViewPreAccountProxy, storage, configService, errorMessageService) {
        super(storage, configService);
        this.formBuilder = formBuilder;
        this.speNOpenAccountProxy = speNOpenAccountProxy;
        this.speViewPreAccountProxy = speViewPreAccountProxy;
        this.storage = storage;
        this.configService = configService;
        this.errorMessageService = errorMessageService;
        this.errorBusinessPartnerMessages = {
            fullname: [
                { type: 'required', message: 'ONBORDING.ADD_PARTNERS.FORM.FULLNAME.MESSAGE.REQUIRED' },
                {
                    type: 'minlength', message: 'ONBORDING.ADD_PARTNERS.FORM.FULLNAME.MESSAGE.MIN_LENGTH',
                    param: { minLength: 6 }
                },
                {
                    type: 'maxlength', message: 'ONBORDING.ADD_PARTNERS.FORM.FULLNAME.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 100 }
                },
                { type: 'pattern', message: 'ONBORDING.ADD_PARTNERS.FORM.FULLNAME.MESSAGE.PATTERN' },
            ],
            docNumber: [
                { type: 'required', message: 'ONBORDING.ADD_PARTNERS.FORM.CPF.MESSAGE.REQUIRED' },
                { type: 'cpfNotValid', message: 'ONBORDING.ADD_PARTNERS.FORM.CPF.MESSAGE.CPF_NOT_VALID' }
            ],
            email: [
                { type: 'required', message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.E_MAIL.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.E_MAIL.MESSAGE.MIN_LENGTH',
                    param: { minLength: 6 },
                },
                {
                    type: 'maxlength',
                    message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.E_MAIL.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 60 },
                },
                { type: 'pattern', message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.E_MAIL.MESSAGE.PATTERN' },
            ],
            phone: [
                { type: 'required', message: 'ONBORDING.COMPANY_DATA.FORM.PHONE.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'ONBORDING.COMPANY_DATA.FORM.PHONE.MESSAGE.MIN_LENGTH',
                    param: { minLength: 15 },
                },
            ],
        };
        this.errorBusinessPersonalMessages = {
            birthDay: [
                { type: 'required', message: 'ONBORDING.DATA_MASTER.FORM.BIRTHDATE.MESSAGE.REQUIRED' },
                {
                    type: 'validDate',
                    message: 'ONBORDING.DATA_MASTER.FORM.BIRTHDATE.MESSAGE.DATE_NOT_VALID'
                },
                {
                    type: 'ptDate',
                    message: 'ONBORDING.DATA_MASTER.FORM.BIRTHDATE.MESSAGE.DATE_NOT_VALID'
                }
            ],
            marital: [
                { type: 'required', message: 'ONBORDING.DATA_MASTER.FORM.BIRTHDATE.MESSAGE.REQUIRED' },
            ],
            motherName: [
                { type: 'required', message: 'ONBORDING.DATA_MASTER.FORM.BIRTHDATE.MESSAGE.REQUIRED' },
            ],
            monthlyIncome: [
                { type: 'required', message: 'ONBORDING.DATA_MASTER.FORM.BIRTHDATE.MESSAGE.REQUIRED' },
            ]
        };
        this.errorBusinessAddressPartnerMessages = {
            postalCode: [
                { type: 'required', message: 'ONBORDING.COMPANY_ADDRESS.FORM.POSTALCODE.MESSAGE.REQUIRED' },
                { type: 'minlength', message: 'ONBORDING.COMPANY_ADDRESS.FORM.POSTALCODE.MESSAGE.MIN_LENGTH', param: { minLength: 9 } },
                { type: 'pattern', message: 'ONBORDING.COMPANY_ADDRESS.FORM.POSTALCODE.MESSAGE.PATTERN' }
            ],
            address: [
                { type: 'required', message: 'ONBORDING.COMPANY_ADDRESS.FORM.ADDRESS.MESSAGE.REQUIRED' },
                { type: 'minlength', param: { minLength: 3 }, message: 'ONBORDING.COMPANY_ADDRESS.FORM.ADDRESS.MESSAGE.MIN_LENGTH' },
                { type: 'maxlength', param: { maxLength: 200 }, message: 'ONBORDING.COMPANY_ADDRESS.FORM.ADDRESS.MESSAGE.MAX_LENGTH' },
            ],
            numberAddress: [
                { type: 'required', message: 'ONBORDING.COMPANY_ADDRESS.FORM.NUMBER_ADDRESS.MESSAGE.REQUIRED' },
                { type: 'maxlength', param: { maxLength: 5 }, message: 'ONBORDING.COMPANY_ADDRESS.FORM.NUMBER_ADDRESS.MESSAGE.MAX_LENGTH' },
            ],
            complementAddress: [
                { type: 'maxlength', param: { maxLength: 60 }, message: 'ONBORDING.COMPANY_ADDRESS.FORM.COMPLEMENT_ADDRESS.MESSAGE.MAX_LENGTH' }
            ],
            neighborhood: [
                { type: 'required', message: 'ONBORDING.COMPANY_ADDRESS.FORM.NEIGHBORHOOD.MESSAGE.REQUIRED' },
                { type: 'minlength', param: { minLength: 3 }, message: 'ONBORDING.COMPANY_ADDRESS.FORM.NEIGHBORHOOD.MESSAGE.MIN_LENGTH' },
                { type: 'maxlength', param: { maxLength: 60 }, message: 'ONBORDING.COMPANY_ADDRESS.FORM.NEIGHBORHOOD.MESSAGE.MAX_LENGTH' }
            ],
            cityAddress: [
                { type: 'required', message: 'ONBORDING.COMPANY_ADDRESS.FORM.CITY_ADDRESS.MESSAGE.REQUIRED' },
                { type: 'minlength', param: { minLength: 3 }, message: 'ONBORDING.COMPANY_ADDRESS.FORM.CITY_ADDRESS.MESSAGE.MIN_LENGTH' },
                { type: 'maxlength', param: { maxLength: 30 }, message: 'ONBORDING.COMPANY_ADDRESS.FORM.CITY_ADDRESS.MESSAGE.MAX_LENGTH' }
            ],
            uf: [
                { type: 'required', message: 'ONBORDING.COMPANY_ADDRESS.FORM.UF.MESSAGE.REQUIRED' }
            ],
            country: [
                { type: 'required', message: 'Campo obrigatório' },
            ],
        };
        this.businessPartnerList = [];
        this.behaviorList = new BehaviorSubject([]);
    }
    getErrorBusinessPartner(error) {
        this.errorMessageService.getError(error);
    }
    updateForm() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            if (!!this.keyPreAccount) {
                this.getPreAccount(this.keyPreAccount);
            }
        });
    }
    getPreAccount(uuid) {
        this.speViewPreAccountProxy.findPartners(uuid).subscribe((data) => {
            this.preAccountBody = data;
            this.businessPartnerList = data.businessPartner;
            this.behaviorList.next(this.businessPartnerList);
        }, (err) => this.errorMessageService.getError(err));
    }
    getMeiOwner() {
        return this.behaviorList.asObservable();
    }
    editForm(businessPartner) {
        this.formBusinessPartner.patchValue({
            fullname: businessPartner.fullname,
            docNumber: businessPartner.docNumber,
            legalRepresentative: businessPartner.legalRepresentative,
            attorney: businessPartner.attorney,
            partner: businessPartner.partner,
            master: businessPartner.master,
            partnerPercentage: businessPartner.partnerPercentage,
        });
        return this.formBusinessPartner;
    }
    getFormBusinessPartner(meiOwnerData) {
        this.formBusinessPartner = this.formBuilder.group({
            fullname: new FormControl((!!meiOwnerData) ? meiOwnerData.fullname : '', Validators.compose([
                Validators.required,
                Validators.minLength(6),
                Validators.maxLength(100),
                Validators.pattern("^([a-zà-úA-ZÀ-Ú]{2,}\\s?([a-zà-úA-ZÀ-Ú]{1,})?\\s[a-zà-úA-ZÀ-Ú]{1,}'?-?[a-zà-úA-ZÀ-Ú]{1,}\\s?([a-zà-úA-ZÀ-Ú]{1,})?\\s?([a-zà-úA-ZÀ-Ú]{1,})?\\s?([a-zà-úA-ZÀ-Ú]{1,})?\\s?([a-zà-úA-ZÀ-Ú]{1,})?)")
            ])),
            docNumber: new FormControl((!!meiOwnerData) ? meiOwnerData.docNumber : '', Validators.compose([
                Validators.required,
                DocumentValidator.isValidCPF
            ])),
            phone: new FormControl((!!meiOwnerData) ? meiOwnerData.phone : '', Validators.compose([
                Validators.required,
                Validators.minLength(15),
            ])),
            email: new FormControl((!!meiOwnerData) ? meiOwnerData.email : '', Validators.compose([
                Validators.required,
                Validators.minLength(6),
                Validators.maxLength(60),
                Validators.pattern('[a-z0-9._%+-]{2,}@[a-z0-9.-]{2,}\\.[a-z]{2,5}')
            ])),
            partnerPercentage: new FormControl((!!meiOwnerData) ? meiOwnerData.partnerPercentage : 0),
        });
        return this.formBusinessPartner;
    }
    getFormBusinessPartnerV2(meiOwnerData) {
        this.formBusinessPartner = this.formBuilder.group({
            fullname: new FormControl((!!meiOwnerData) ? meiOwnerData.fullname : '', Validators.compose([
                Validators.required,
                Validators.minLength(6),
                Validators.maxLength(100),
                Validators.pattern("^([a-zà-úA-ZÀ-Ú]{2,}\\s?([a-zà-úA-ZÀ-Ú]{1,})?\\s[a-zà-úA-ZÀ-Ú]{1,}'?-?[a-zà-úA-ZÀ-Ú]{1,}\\s?([a-zà-úA-ZÀ-Ú]{1,})?\\s?([a-zà-úA-ZÀ-Ú]{1,})?\\s?([a-zà-úA-ZÀ-Ú]{1,})?\\s?([a-zà-úA-ZÀ-Ú]{1,})?)")
            ])),
            docNumber: new FormControl((!!meiOwnerData) ? meiOwnerData.docNumber : '', Validators.compose([
                Validators.required,
                DocumentValidator.isValidCPF
            ])),
            phone: new FormControl((!!meiOwnerData) ? meiOwnerData.phone : '', Validators.compose([
                Validators.required,
                Validators.minLength(15),
            ])),
            partnerPercentage: new FormControl((!!meiOwnerData) ? meiOwnerData.partnerPercentage : 0),
        });
        return this.formBusinessPartner;
    }
    getFormPersonalData(meiOwnerPersonalData) {
        this.formPersonalData = this.formBuilder.group({
            birthDay: new FormControl((!!meiOwnerPersonalData) ? this.formatDate(meiOwnerPersonalData.birthDay) : '', Validators.compose([
                Validators.required,
                DateValidator.ptDate,
                DateValidator.validDate
            ])),
            marital: new FormControl((!!meiOwnerPersonalData) ? meiOwnerPersonalData.marital : '', Validators.compose([
                Validators.required,
            ])),
            motherName: new FormControl((!!meiOwnerPersonalData) ? meiOwnerPersonalData.motherName : '', Validators.compose([
                Validators.required,
                Validators.minLength(6),
            ])),
            monthlyIncome: new FormControl((!!meiOwnerPersonalData) ? meiOwnerPersonalData.monthlyIncome : '', Validators.compose([
                Validators.required,
                Validators.minLength(1)
            ]))
        });
        return this.formPersonalData;
    }
    formatDate(date) {
        const dateFull = new Date(date);
        const day = dateFull.getDate().toString(), dayF = day.length == 1 ? '0' + day : day, month = (dateFull.getMonth() + 1).toString(), monthF = month.length == 1 ? '0' + month : month, year = dateFull.getFullYear();
        return dayF + '/' + monthF + '/' + year;
    }
    getBusinessAddressForm(meiOwnerAddressData) {
        this.formBusinessAddressPartner = this.formBuilder.group({
            postalCode: new FormControl((!!meiOwnerAddressData) ? meiOwnerAddressData.postalCode : '', Validators.compose([
                Validators.required,
                Validators.minLength(9),
                Validators.pattern('^[a-zA-Z0-9_.+-]+$')
            ])),
            address: new FormControl((!!meiOwnerAddressData) ? meiOwnerAddressData.address : '', Validators.compose([
                Validators.required,
                Validators.minLength(3),
                Validators.maxLength(200),
            ])),
            numberAddress: new FormControl((!!meiOwnerAddressData) ? meiOwnerAddressData.numberAddress : '', Validators.compose([
                Validators.required,
                Validators.maxLength(30),
            ])),
            complementAddress: new FormControl((!!meiOwnerAddressData) ? meiOwnerAddressData.complementAddress : '', Validators.compose([
                Validators.maxLength(60),
            ])),
            neighborhood: new FormControl((!!meiOwnerAddressData) ? meiOwnerAddressData.neighborhood : '', Validators.compose([
                Validators.required,
                Validators.minLength(3),
                Validators.maxLength(60)
            ])),
            cityAddress: new FormControl((!!meiOwnerAddressData) ? meiOwnerAddressData.cityAddress : '', Validators.compose([
                Validators.required,
                Validators.minLength(3),
                Validators.maxLength(30)
            ])),
            uf: new FormControl((!!meiOwnerAddressData) ? meiOwnerAddressData.uf : '', Validators.compose([
                Validators.required,
                Validators.minLength(2)
            ])),
            country: new FormControl((!!meiOwnerAddressData) ? meiOwnerAddressData.country : 'br'),
        });
        return this.formBusinessAddressPartner;
    }
    searchPostaCode(zipcode) {
        if (zipcode !== '' && zipcode !== null) {
            this.speNOpenAccountProxy
                .getCep(zipcode)
                .subscribe(data => this.updateAddress(data), error => this.errorMessageService.getError(error));
        }
    }
    updateAddress(address) {
        this.formBusinessAddressPartner.patchValue({
            address: address.logradouro,
            neighborhood: address.bairro,
            cityAddress: address.localidade,
            uf: address.uf,
            country: 'br'
        });
    }
    getFormBusinessPartnerError() {
        return this.errorBusinessPartnerMessages;
    }
    getFormBusinessPersonalError() {
        return this.errorBusinessPersonalMessages;
    }
    getFormBusinessAddressError() {
        return this.errorBusinessAddressPartnerMessages;
    }
    getResponsibleId() {
        return this.responsibleId;
    }
    sendFormBusinessPartner(businessPartner, idOwner) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            if (!!idOwner) {
                this.responsibleId = idOwner;
                const businessPartnerList = {
                    id: idOwner,
                    fullname: businessPartner.fullname,
                    docNumber: businessPartner.docNumber,
                    email: businessPartner.email,
                    phone: businessPartner.phone,
                    partnerPercentage: businessPartner.partnerPercentage
                };
                this.preAccountBody.businessPartner.splice(0, 1, businessPartnerList);
                yield this.editPartner(businessPartner, idOwner);
            }
            else {
                yield this.createBusinessPartner(businessPartner);
            }
        });
    }
    createBusinessPartner(preAccount) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            this.speNOpenAccountProxy.createBusinessPartner(this.keyPreAccount, preAccount)
                .subscribe(res => this.responsibleId = res.id);
        });
    }
    sendFormBusinessPersonal(preAccount, id) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            const obj = {
                personalData: preAccount,
                id: (!!id) ? id : this.getResponsibleId()
            };
            this.speNOpenAccountProxy.updateBusinessPersonalPartnerData(this.keyPreAccount, obj).subscribe((res) => this.behaviorList.next(res.formPersonalData), (error) => {
                // console.error('error', error);
            });
        });
    }
    sendFormBusinessAddress(preAccount, id) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            const obj = {
                personalAddress: preAccount,
                id: (!!id) ? id : this.getResponsibleId()
            };
            this.speNOpenAccountProxy.updateBusinessAddressPartnerData(this.keyPreAccount, obj).subscribe((res) => this.behaviorList.next(res.formPersonalData), (error) => {
                // console.error('error', error);
            });
        });
    }
    editPartner(preAccount, id) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            const obj = Object.assign({}, preAccount, { id: (!!id) ? id : this.getResponsibleId() });
            this.speNOpenAccountProxy.updateBusinessPartner(this.keyPreAccount, obj).subscribe((res) => this.behaviorList.next(res.formPersonalData), (error) => {
                // console.error('error', error);
            });
        });
    }
    removePartner(partnerId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            return this.speNOpenAccountProxy
                .removePartner(this.keyPreAccount, partnerId).toPromise();
        });
    }
};
ResponsibleMeiService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [FormBuilder,
        SpeNOpenAccountProxy,
        SpeViewPreAccountProxy,
        Storage,
        ConfigService,
        ErrorMessageService])
], ResponsibleMeiService);

let StatusAccountService = class StatusAccountService extends BaseService {
    constructor(speViewPreAccountProxy, storage, configService) {
        super(storage, configService);
        this.speViewPreAccountProxy = speViewPreAccountProxy;
        this.storage = storage;
        this.configService = configService;
    }
    loadStatus() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            return this.speViewPreAccountProxy.findStatusById(this.keyPreAccount).toPromise();
        });
    }
    getTitle(status) {
        if (status === Status.IN_ANALYSIS_COMPLIANCE ||
            status === Status.APPROVED_COMPLIANCE ||
            status === Status.IN_ANALYSIS_BACKOFFICE ||
            status === Status.APPROVED_BACKOFFICE ||
            status === Status.IN_ANALYSIS_TOPAZIO ||
            status === Status.APPROVED_TOPAZIO) {
            return 'ONBORDING.STATUS_ACCOUNT.IN_ANALYSIS.DESCRIPTION_TITLE';
        }
        else if (status === Status.DOCUMENT_LEGAL_PERSON_REPROVED ||
            status === Status.DOCUMENT_PHYSICAL_PERSON_REPROVED) {
            return 'ONBORDING.STATUS_ACCOUNT.DOCUMENT_INVALID.DESCRIPTION_TITLE';
        }
        else if (status === Status.REGISTRATION_DATA_LEGAL_PERSON_INVALID ||
            status === Status.REGISTRATION_DATA_PHYSICAL_PERSON_INVALID) {
            return 'ONBORDING.STATUS_ACCOUNT.DATA_INVALID.DESCRIPTION_TITLE';
        }
        else if (status === Status.REPROVED) {
            return 'ONBORDING.STATUS_ACCOUNT.REPROVED.DESCRIPTION_TITLE';
        }
        else if (status === Status.FINISHED) {
            return 'ONBORDING.STATUS_ACCOUNT.APPROVED.DESCRIPTION_TITLE';
        }
    }
    getDescription(status) {
        if (status === Status.IN_ANALYSIS_COMPLIANCE ||
            status === Status.APPROVED_COMPLIANCE ||
            status === Status.IN_ANALYSIS_BACKOFFICE ||
            status === Status.APPROVED_BACKOFFICE ||
            status === Status.IN_ANALYSIS_TOPAZIO ||
            status === Status.APPROVED_TOPAZIO) {
            return 'ONBORDING.STATUS_ACCOUNT.IN_ANALYSIS.DESCRIPTION';
        }
        else if (status === Status.DOCUMENT_LEGAL_PERSON_REPROVED ||
            status === Status.DOCUMENT_PHYSICAL_PERSON_REPROVED) {
            return 'ONBORDING.STATUS_ACCOUNT.DOCUMENT_INVALID.DESCRIPTION';
        }
        else if (status === Status.REGISTRATION_DATA_LEGAL_PERSON_INVALID ||
            status === Status.REGISTRATION_DATA_PHYSICAL_PERSON_INVALID) {
            return 'ONBORDING.STATUS_ACCOUNT.DATA_INVALID.DESCRIPTION';
        }
        else if (status === Status.REPROVED) {
            return 'ONBORDING.STATUS_ACCOUNT.REPROVED.DESCRIPTION';
        }
        else if (status === Status.FINISHED) {
            return 'ONBORDING.STATUS_ACCOUNT.APPROVED.DESCRIPTION';
        }
    }
    getTextButton(status) {
        if (status === Status.IN_ANALYSIS_COMPLIANCE ||
            status === Status.APPROVED_COMPLIANCE ||
            status === Status.IN_ANALYSIS_BACKOFFICE ||
            status === Status.APPROVED_BACKOFFICE ||
            status === Status.IN_ANALYSIS_TOPAZIO ||
            status === Status.APPROVED_TOPAZIO) {
            return 'ONBORDING.STATUS_ACCOUNT.IN_ANALYSIS.BUTTON';
        }
        else if (status === Status.DOCUMENT_LEGAL_PERSON_REPROVED ||
            status === Status.DOCUMENT_PHYSICAL_PERSON_REPROVED) {
            return 'ONBORDING.STATUS_ACCOUNT.DOCUMENT_INVALID.BUTTON';
        }
        else if (status === Status.REGISTRATION_DATA_LEGAL_PERSON_INVALID ||
            status === Status.REGISTRATION_DATA_PHYSICAL_PERSON_INVALID) {
            return 'ONBORDING.STATUS_ACCOUNT.DATA_INVALID.BUTTON';
        }
        else if (status === Status.REPROVED) {
            return 'ONBORDING.STATUS_ACCOUNT.REPROVED.BUTTON';
        }
        else if (status === Status.FINISHED) {
            return 'ONBORDING.STATUS_ACCOUNT.APPROVED.BUTTON';
        }
    }
};
StatusAccountService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [SpeViewPreAccountProxy,
        Storage,
        ConfigService])
], StatusAccountService);

let StepFlowService = class StepFlowService extends BaseService {
    constructor(configService, storage, speNOpenAccountProxy, speViewPreAccountProxy, accountTypeService, createAccountService) {
        super(storage, configService);
        this.configService = configService;
        this.storage = storage;
        this.speNOpenAccountProxy = speNOpenAccountProxy;
        this.speViewPreAccountProxy = speViewPreAccountProxy;
        this.accountTypeService = accountTypeService;
        this.createAccountService = createAccountService;
    }
    updateStep(step) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            if (!!this.keyPreAccount) {
                yield this.speNOpenAccountProxy.updateStep(this.keyPreAccount, step).toPromise();
            }
        });
    }
    getSteps(whiteLabel, currentStep, isFirt, isStart) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            const path = '/onboarding';
            currentStep ? currentStep = currentStep.replace(path, '') : '';
            let type = yield this.accountTypeService.getTemporaryTypeAccount();
            let data;
            const name = yield this.accountTypeService.getName();
            const typeName = yield this.accountTypeService.getNameType();
            const wlName = whiteLabel.wlThemeParameterization.wlTheme.wlName;
            // Se for a primeira tela ele vai limpar o cache
            if (isFirt) {
                yield this.accountTypeService.temporaryTypeAccount(null);
                yield this.accountTypeService.setName(null);
                yield this.accountTypeService.setNameType(null);
                yield this.accountTypeService.setListStep(null);
            }
            // Verificar se é PF ou PJ
            const isPF = type === 'PHYSICAL_PERSON' || type === 'LIBERAL_PROFESSIONAL' || type === 'ESCROW_PHYSICAL_PERSON';
            if (!type || isStart) {
                type = TypeAccountEnum$1.START;
            }
            if (type === TypeAccountEnum$1.START) {
                data = yield this.speViewPreAccountProxy.getSteps(whiteLabel.wlp, type).toPromise();
            }
            else {
                // Busca do cache
                data = yield this.accountTypeService.getListStep();
                // Se não encontra ele faz uma nova request
                if (!data) {
                    data = yield this.speViewPreAccountProxy.getOnboardingAccountStep(this.keyPreAccount).toPromise();
                    yield this.accountTypeService.setListStep(data);
                }
            }
            if (!data && !data.steps) {
                return;
            }
            let stepsCurrent = currentStep ? data.steps.filter(el => el.currentStep === currentStep)[0] : data.steps[0];
            if (stepsCurrent) {
                if (stepsCurrent.previousStep && stepsCurrent.previousStep !== '/') {
                    stepsCurrent.previousStep = path + stepsCurrent.previousStep;
                }
                if (stepsCurrent.nextStep && stepsCurrent.nextStep !== '/') {
                    stepsCurrent.nextStep = path + stepsCurrent.nextStep;
                }
                if (stepsCurrent.currentStep && stepsCurrent.currentStep !== '/') {
                    stepsCurrent.currentStep = path + stepsCurrent.currentStep;
                }
                !!name ? stepsCurrent = Object.assign({}, stepsCurrent, { name }) : null;
                !!type ? stepsCurrent = Object.assign({}, stepsCurrent, { isPF }) : null;
                !!stepsCurrent.titlePage ? stepsCurrent.titlePage = stepsCurrent.titlePage
                    .replace('USER_NAME', name)
                    .replace('ACCOUNT_TYPE', typeName)
                    .replace('WHITE_LABEL_NAME', wlName) : null;
                !!stepsCurrent.description ? stepsCurrent.description = stepsCurrent.description
                    .replace('USER_NAME', name)
                    .replace('ACCOUNT_TYPE', typeName)
                    .replace('WHITE_LABEL_NAME', wlName) : null;
            }
            return stepsCurrent;
        });
    }
    getStepsWithExternalValidationFlow(whiteLabel, currentStep, isStart) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            let initialPath = !!currentStep ? currentStep.split('/').filter(item => { return item !== ''; })[0] : '';
            const pathFormated = currentStep ? currentStep.replace(`/${initialPath}`, '') : '';
            let type = yield this.accountTypeService.getTemporaryTypeAccount();
            let data;
            const name = yield this.accountTypeService.getName();
            const typeName = yield this.accountTypeService.getNameType();
            const wlName = whiteLabel.wlThemeParameterization.wlTheme.wlName;
            // // Verificar se é PF ou PJ
            const isPF = type === 'PHYSICAL_PERSON_IDUNICO';
            if (isStart) {
                type = TypeAccountEnum$1.START_ONBOARDING_UNICO;
            }
            if (type) {
                data = yield this.speViewPreAccountProxy.getSteps(whiteLabel.wlp, type).toPromise();
            }
            else {
                // Busca do cache
                data = yield this.accountTypeService.getListStep();
                // Se não encontra ele faz uma nova request
                if (!data) {
                    data = yield this.speViewPreAccountProxy.findAccountTypeByWhiteLabelVisible(whiteLabel.wlp).toPromise();
                }
            }
            yield this.accountTypeService.setListStep(data);
            if (!data && !data.steps) {
                return;
            }
            let stepsCurrent = pathFormated ? data.steps.filter(el => el.currentStep === pathFormated)[0] : data.steps[0];
            if (stepsCurrent) {
                initialPath = !initialPath.startsWith('/') ? '/' + initialPath : initialPath;
                if (stepsCurrent.previousStep && stepsCurrent.previousStep !== '/') {
                    stepsCurrent.previousStep = initialPath + stepsCurrent.previousStep;
                }
                if (stepsCurrent.nextStep && stepsCurrent.nextStep !== '/') {
                    stepsCurrent.nextStep = initialPath + stepsCurrent.nextStep;
                }
                if (stepsCurrent.currentStep && stepsCurrent.currentStep !== '/') {
                    stepsCurrent.currentStep = initialPath + stepsCurrent.currentStep;
                }
                !!name ? stepsCurrent = Object.assign({}, stepsCurrent, { name }) : null;
                !!type ? stepsCurrent = Object.assign({}, stepsCurrent, { isPF }) : null;
                !!stepsCurrent.titlePage ? stepsCurrent.titlePage = stepsCurrent.titlePage
                    .replace('USER_NAME', name)
                    .replace('ACCOUNT_TYPE', typeName)
                    .replace('WHITE_LABEL_NAME', wlName) : null;
                !!stepsCurrent.description ? stepsCurrent.description = stepsCurrent.description
                    .replace('USER_NAME', name)
                    .replace('ACCOUNT_TYPE', typeName)
                    .replace('WHITE_LABEL_NAME', wlName) : null;
            }
            return stepsCurrent;
        });
    }
    nextStep(navCtrl, dataStep, force) {
        return __awaiter(this, void 0, void 0, function* () {
            if (dataStep && dataStep.updateStatus) {
                const formData = { status: dataStep.statusSend };
                yield this.createAccountService.updateStatus(formData);
            }
            if (force) {
                window.location.href = dataStep.nextStep;
            }
            else {
                yield navCtrl.navigateForward(dataStep.nextStep);
            }
        });
    }
    backStep(navCtrl, dataStep) {
        return __awaiter(this, void 0, void 0, function* () {
            if (dataStep && dataStep.previousStep) {
                yield navCtrl.navigateBack(dataStep.previousStep);
            }
        });
    }
};
StepFlowService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ConfigService,
        Storage,
        SpeNOpenAccountProxy,
        SpeViewPreAccountProxy,
        AccountTypeService,
        CreateAccountService])
], StepFlowService);

class UploadResponse {
}

let UploadService = class UploadService extends BaseService {
    constructor(speNOpenAccountUploadProxy, speViewPreAccountProxy, speNOpenAccountProxy, storage, configService, errorMessageService) {
        super(storage, configService);
        this.speNOpenAccountUploadProxy = speNOpenAccountUploadProxy;
        this.speViewPreAccountProxy = speViewPreAccountProxy;
        this.speNOpenAccountProxy = speNOpenAccountProxy;
        this.storage = storage;
        this.configService = configService;
        this.errorMessageService = errorMessageService;
        this.listDocumentUploaded = [];
        this.preAccount = new PreAccountResponse();
    }
    uploadFile(file) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            const uploadFile = this.prepareUpload(file);
            return this.speNOpenAccountUploadProxy.uploadFile(this.keyPreAccount, uploadFile).toPromise();
        });
    }
    uploadPartnerFile(file, partnerId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            const uploadFile = this.prepareUpload(file);
            return this.speNOpenAccountUploadProxy.uploadPartnerFile(this.keyPreAccount, partnerId, uploadFile).toPromise();
        });
    }
    getErroUpload(err) {
        this.errorMessageService.getError(err);
    }
    loadDocumentuploaded() {
        return __awaiter(this, void 0, void 0, function* () {
            this.listDocumentUploaded = [];
            yield this.loadKey();
            if (!!this.keyPreAccount) {
                this.speViewPreAccountProxy.findUploads(this.keyPreAccount).subscribe((list) => {
                    this.setListUploded(list);
                }, (err) => {
                    this.getErroUpload(err);
                });
            }
        });
    }
    setListUploded(list) {
        this.listDocumentUploaded = list;
    }
    isDocumentUploaded(typeDocument) {
        if (!!this.listDocumentUploaded) {
            const index = this.listDocumentUploaded.findIndex((item) => item.typeDocument.toString() === typeDocument);
            return index > -1;
        }
        return false;
    }
    isDocumentReturned(typeDocument, isDocument) {
        if (!!this.listDocumentUploaded && this.listDocumentUploaded.length > 0) {
            if ((typeDocument === 'RG' || typeDocument === 'CNH') && !isDocument) {
                if (this.isDocumentUploaded('RG') || this.isDocumentUploaded('CNH')) {
                    const index = this.listDocumentUploaded.findIndex((item) => (item.typeDocument.toString() === 'RG' || item.typeDocument.toString() === 'CNH') &&
                        item.status.toUpperCase() === 'ACTIVE');
                    return !(index > -1);
                }
                return false;
            }
            if (!this.isDocumentUploaded(typeDocument)) {
                return false;
            }
            const index2 = this.listDocumentUploaded.findIndex((item) => item.typeDocument.toString() === typeDocument && item.status.toUpperCase() === 'ACTIVE');
            return !(index2 > -1);
        }
        return false;
    }
    isVisible(valid, type) {
        // const hasReturnOnList = this.isDocumentReturnedOnlist();
        // if (!valid) {
        //   return false;
        // }
        // if (valid && !hasReturnOnList) {
        //   return true;
        // }
        // if ( valid && hasReturnOnList && this.isDocumentReturned(type)) {
        //   return true;
        // }
        return valid;
    }
    getAccountType() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            return this.speViewPreAccountProxy.findAccountType(this.keyPreAccount).toPromise();
        });
    }
    createFileAccount(fileAccount) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.addItem(this.configService.getTypeUpload(), fileAccount);
        });
    }
    loadFileTypeUpload() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadTypeUpload();
            return this.typeUpload;
        });
    }
    removeFileTypeUpload() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.removeItem(this.configService.getTypeUpload());
        });
    }
    prepareUpload(file) {
        const uploadResponse = new UploadResponse();
        uploadResponse.fileBase64 = file.fileBase64.photo;
        uploadResponse.uploadType = UploadTypeEnum[file.uploadType];
        uploadResponse.positionPhoto = PositionPhotoEnum[file.positionPhoto];
        uploadResponse.fileName = file.title;
        uploadResponse.ownership = file.ownership;
        return uploadResponse;
    }
    loadAccount() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            this.speViewPreAccountProxy.findPreAccount(this.keyPreAccount).subscribe((res) => (this.preAccount = res), (err) => this.getErroUpload(err));
        });
    }
    findDocumentsToUpload(step) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            return yield this.speNOpenAccountProxy.findDocumentsToUpload(this.keyPreAccount, step).toPromise();
        });
    }
    findDocumentsPartnerToUpload(idBusinessPartner, step) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            return yield this.speNOpenAccountProxy.findDocumentsPartnerToUpload(this.keyPreAccount, idBusinessPartner, step).toPromise();
        });
    }
};
UploadService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [SpeNOpenAccountUploadProxy,
        SpeViewPreAccountProxy,
        SpeNOpenAccountProxy,
        Storage,
        ConfigService,
        ErrorMessageService])
], UploadService);

let UserInterestsService = class UserInterestsService extends BaseService {
    constructor(speNOpenAccountProxy, speViewPreAccountProxy, storage, configService) {
        super(storage, configService);
        this.speNOpenAccountProxy = speNOpenAccountProxy;
        this.speViewPreAccountProxy = speViewPreAccountProxy;
        this.storage = storage;
        this.configService = configService;
        this.preAccount = new PreAccountResponse();
        this.loadKey();
    }
    /**
     * retorna os dados do usuario atual
     */
    getUserData() {
        return this.speViewPreAccountProxy.findPreAccount(this.keyPreAccount);
    }
    /**
     * retorna a lista de interesses cadastrados no white label
     * @param uuidWL
     */
    getInterests(uuidWL) {
        return this.speViewPreAccountProxy.findInterests(uuidWL)
            .pipe(map((result) => {
            return result.filter(res => res.deleted === 0);
        }));
    }
    /**
     * cadastra os produtos de interesse do usuario
     * @param userid
     * @param interests
     */
    addUserInterest(userid, interests) {
        return this.speNOpenAccountProxy.addUserInterest(userid, interests);
    }
};
UserInterestsService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [SpeNOpenAccountProxy,
        SpeViewPreAccountProxy,
        Storage,
        ConfigService])
], UserInterestsService);

let LivenessService = class LivenessService extends BaseService {
    constructor(speNOpenAccountProxy, storage, configService) {
        super(storage, configService);
        this.speNOpenAccountProxy = speNOpenAccountProxy;
        this.storage = storage;
        this.configService = configService;
    }
    createLiveness(body) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            return this.speNOpenAccountProxy.createLiveness(this.keyPreAccount, body).toPromise();
        });
    }
    finalizeLiveness(preAccountId) {
        return this.speNOpenAccountProxy.finalizeLiveness(preAccountId);
    }
};
LivenessService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [SpeNOpenAccountProxy,
        Storage,
        ConfigService])
], LivenessService);

var UiBsSignupModule_1;
let UiBsSignupModule = UiBsSignupModule_1 = class UiBsSignupModule {
    constructor(parentModule) {
        //...
    }
    static forRoot(config) {
        return {
            ngModule: UiBsSignupModule_1,
            providers: [
                { provide: APP_PARAMETER, useValue: config }
            ]
        };
    }
};
UiBsSignupModule = UiBsSignupModule_1 = __decorate([
    NgModule({
        imports: [
            CommonModule,
            FormsModule,
            IonicModule,
            IonicStorageModule.forRoot({
                driverOrder: ['indexeddb', 'sqlite', 'websql']
            }),
            BrowserModule,
            UiBsTranslateModule,
            UiPxSignupModule,
            UiBsUtilModule,
            RxReactiveFormsModule
        ],
        providers: [
            CreateAccountService,
            PersonalDataService,
            PersonalAddressService,
            CompanyAddressService,
            ContractService,
            CompanyDataService,
            ComercialAgentService,
            BusinessPartnerService,
            ProfessionalTypeService,
            ProfessionalTypeService,
            AccountTypeService,
            UploadService,
            AddPartnerService,
            PartnersService,
            StepFlowService,
            StatusAccountService,
            UserInterestsService,
            ResponsibleMeiService,
            LivenessService
        ],
        exports: [RxReactiveFormsModule]
    }),
    __param(0, Optional()), __param(0, SkipSelf()),
    __metadata("design:paramtypes", [UiBsSignupModule])
], UiBsSignupModule);

class FileAccount {
}

class AccountPaymentTypeResponse {
}

var TypeAccountEnum;
(function (TypeAccountEnum) {
    TypeAccountEnum["PHYSICAL_PERSON"] = "PHYSICAL_PERSON";
    TypeAccountEnum["LEGAL_PERSON"] = "LEGAL_PERSON";
    TypeAccountEnum["MEI"] = "MEI";
    TypeAccountEnum["LIBERAL_PROFESSIONAL"] = "LIBERAL_PROFESSIONAL";
    TypeAccountEnum["PHYSICAL_PERSON_IDUNICO"] = "PHYSICAL_PERSON_IDUNICO";
    TypeAccountEnum["MEI_IDUNICO"] = "MEI_IDUNICO";
    // Tipo de Flow do Onboardin
    TypeAccountEnum["START"] = "START";
    TypeAccountEnum["START_ONBOARDING_UNICO"] = "START_ONBOARDING_UNICO";
})(TypeAccountEnum || (TypeAccountEnum = {}));

class ReportBureausDto {
}
var ReportBureausStatusEnum;
(function (ReportBureausStatusEnum) {
    ReportBureausStatusEnum["CONCLUIDO"] = "CONCLUIDO";
    ReportBureausStatusEnum["EM_ANALISE"] = "EM ANALISE";
    ReportBureausStatusEnum["PRE_PROCESSANDO"] = "PRE-PROCESSANDO";
    ReportBureausStatusEnum["PROCESSANDO"] = "PROCESSANDO";
})(ReportBureausStatusEnum || (ReportBureausStatusEnum = {}));
var ReportBureausTypeEnum;
(function (ReportBureausTypeEnum) {
    ReportBureausTypeEnum["IDWALL"] = "IDWALL";
    ReportBureausTypeEnum["SERASA"] = "SERASA";
    ReportBureausTypeEnum["IDUNICO"] = "IDUNICO";
})(ReportBureausTypeEnum || (ReportBureausTypeEnum = {}));
class ReportDetailBase {
    constructor(historyConsult) {
        this.historyConsult = historyConsult;
    }
}
class HystoryConsult {
}

export { AccountPaymentTypeResponse, AccountTypeService, AddPartnerService, BusinessPartnerService, ComercialAgentService, CompanyAddressService, CompanyDataService, ContractService, CreateAccountService, FileAccount, HystoryConsult, LivenessService, PartnersService, PersonalAddressService, PersonalDataService, PreAccountResponse, ProfessionalTypeService, ReportBureausDto, ReportBureausStatusEnum, ReportBureausTypeEnum, ReportDetailBase, ResponsibleMeiService, StatusAccountService, StepFlowService, TypeAccountEnum, UiBsSignupModule, UploadService, UserInterestsService };
//# sourceMappingURL=wlp-ui-bs-signup.js.map
